<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row style="position:relative;">
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Продажа <span v-if="sale.org">({{ sale.org.legal_entity }})</span></div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Ресепшен / Рабочий стол /</span> Продажа</div>
                </div>
              </v-col>
              <v-col cols="12">
                <v-sheet
                    max-height="80px"
                    rounded="lg"
                    class="d-flex justify-space-between align-center card"
                >
                <div style="display:flex; flex-direction: column;">
               
                  <div v-if="saleInfo && type && type !=='new'" style="display:flex; align-items:center;">
                    <div>Клиент: </div>
                    <router-link
                                                v-if="saleInfo.sales.client && saleInfo.sales.client.id"
                                                    :to="{ name: 'CardClientNew', params: {client_id: saleInfo.sales.client.id}}"
                                                    class="d-flex"
                                                    style="align-items: center; text-decoration: none; color: #000"
                                                >
                                                  <span>{{ saleInfo.sales.client.name }}</span>

                                            </router-link>
                    </div>

                    <div v-else>
                      <div v-if="client && client.name">
                        {{ client && client.name }}
                      </div>
                      <div v-else>
                        {{ client.last_name}} {{client.first_name }}
                      </div>
                    </div>
                  </div>
                  <v-tabs
                      centered
                      id="horizontal_tabs"
                      v-model="sale_tab"
                      class="d-flex align-center sale__tab"
                  >
                    <v-tab
                        v-for="item in sales"
                        :key="item.tab"
                        class="ml-4"
                    >
                      {{ item.tab }}
                    </v-tab>
                  </v-tabs>
                </v-sheet>
              </v-col>
              <v-col
                  cols="4"
                  v-if="(type === 'new') || (type === 'exist' && sale_tab === 1) || (type === 'info' && sale_tab === 1) || (type === 'edit')"
              >
              
                <v-tabs-items v-model="sale_tab">
                  <v-tab-item>
                    <v-skeleton-loader
                        v-if="isLoadingSale && (type === 'new' || type === 'edit')"
                        type="table-tbody"
                    >
                    </v-skeleton-loader>
                    <v-sheet
                        v-else
                        class="card"
                        rounded="lg" 
                    >
                    <div class="" style="margin-bottom: 20px;">
                        <label>Организация</label>
                        <v-select
                            v-if="listCashbox && listCashbox.length > 0"
                            v-model="sale.org"
                            :items="listCashbox"
                            item-value="inn"
                            item-text="legal_entity"
                            return-object
                            class="rounded-lg"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            @change="ChangeSaleOrg()"
                            style="height: 48px;margin-top: 10px"
                        ></v-select>
                        <v-select
                            v-else
                            v-model="saleOrg"
                            :items="listOrganizations.sales"
                            item-value="inn"
                            item-text="name"
                            return-object
                            class="rounded-lg"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            @change="ChangeSaleOrg()"
                            style="height: 48px;margin-top: 10px"
                        ></v-select>
                      </div>

                      <v-text-field
                          v-model="searchService"
                          hide-details
                          dense
                          required
                          label="Поиск"
                          outlined
                          style="font-weight: 400; font-size: 16px; line-height: 24px;"
                          background-color="white"
                          color="#629F33"
                          class="search-service"
                          @input="handleSearch"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon>mdi-magnify</v-icon>
                        </template>
                      </v-text-field>
        
                      <template>
                        <v-treeview
                            v-if="listAllServices"
                            :items="listAllServices.sales"
                            item-key="id"
                            item-text="name"
                            :search="searchService"
                            expand-icon="mdi-chevron-down"
                            open-on-click
                            item-children="list"
                            :filter="searchPackages"
                            ref="myTree"
                        >
                          <template v-slot:label="{ item, leaf }">
                            <v-list-item
                                class="service"
                                v-if="leaf"
                                :key="item.name"
                                @click="addToNomenclature(item)"
                            >
                              <v-list-item-title class="d-flex justify-space-between">
                                <span class="service-title">{{ item.name }}</span>
                                <span class="service-price" v-if="item.price">{{ item.free ? 'беспл.' : item.price + '  ₽' }}</span>
                              </v-list-item-title>
                            </v-list-item>
                 
                            <v-list-item
                                :key="item.name"
                                class="services"
                                v-else
                            >
                              <v-list-item-title>{{ item.name }}</v-list-item-title>
                            </v-list-item>
                          </template>
                        </v-treeview>
                      </template>
                    </v-sheet>
                  </v-tab-item>
                  <v-tab-item>
                    <v-sheet
                        class="card"
                        rounded="lg"
                        v-if="type === 'new'"
                    >
                      <div>
                        <label>Номер</label>
                        <v-text-field
                            v-model="sale.number"
                            label="Номер"
                            outlined
                            readonly
                            dense
                            style="height: 48px;margin-top: 10px"
                            class="rounded-lg"
                        ></v-text-field>
                      </div>
                      <div class="mt-5">
                        <label>Дата</label>
                        <template>
                          <VueDatePicker
                              no-title
                              no-header
                              color="#629f34"
                              v-model="sale.date"
                              placeholder="Дата"
                          >
                            <template #activator="{ date }">
                              <button
                                  class="button custom__datepicker"
                                  ref="activator"
                                  type="button"
                              >
                                <div>
                                  <span v-if="date">{{ date }}</span>
                                  <span v-else style="color: gray">Дата</span>
                                </div>
                                <div>
                                  <v-icon
                                      medium
                                      right
                                      class="ml-5"
                                  >
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                </div>
                              </button>
                            </template>
                          </VueDatePicker>
                        </template>
                      </div>
                      <div class="mt-5">
                        <label>Автор</label>
                        <v-text-field
                            v-model="userFIO"
                            label="Автор"
                            outlined
                            readonly
                            dense
                            style="height: 48px;margin-top: 10px"
                            class="rounded-lg"
                        ></v-text-field>
                      </div>
                      <!-- <div class="mt-5">
                        <label>Организация</label>
                        <v-select
                            v-if="listCashbox && listCashbox.length > 0"
                            v-model="sale.org"
                            :items="listCashbox"
                            item-value="inn"
                            item-text="legal_entity"
                            return-object
                            class="rounded-lg"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            @change="ChangeSaleOrg()"
                            style="height: 48px;margin-top: 10px"
                        ></v-select>
                        <v-select
                            v-else
                            v-model="saleOrg"
                            :items="listOrganizations.sales"
                            item-value="inn"
                            item-text="name"
                            return-object
                            class="rounded-lg"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            @change="ChangeSaleOrg()"
                            style="height: 48px;margin-top: 10px"
                        ></v-select>
                      </div> -->
<!--                      <div class="mt-5">-->
<!--                        <label>Промокод</label>-->
<!--                        <v-text-field-->
<!--                            v-model="sale.promocode"-->
<!--                            label="Промокод"-->
<!--                            outlined-->
<!--                            readonly-->
<!--                            dense-->
<!--                            style="height: 48px;margin-top: 10px"-->
<!--                            class="rounded-lg"-->
<!--                        ></v-text-field>-->
<!--                      </div>-->
                    </v-sheet>
                    <v-sheet
                        class="card"
                        rounded="lg"
                        v-if="type === 'exist' || type === 'edit' || type === 'info'"
                    >
                      <div>
                        <label>Номер</label>
                        <v-text-field
                            v-model="saleInfo.sales.number"
                            label="Номер"
                            outlined
                            readonly
                            dense
                            style="height: 48px;margin-top: 10px"
                            class="rounded-lg"
                        ></v-text-field>
                      </div>
                      <div class="mt-5">
                        <label>Дата</label>
                        <template>
                          <VueDatePicker
                              no-title
                              no-header
                              color="#629f34"
                              v-model="saleInfo.sales.date"
                              placeholder="Дата"
                              disabled
                          >
                            <template #activator="{ date }">
                              <button
                                  class="button custom__datepicker2"
                                  ref="activator"
                                  type="button"
                              >
                                <div>
                                  <span v-if="date">{{ date }}</span>
                                  <span v-else style="color: gray">Дата</span>
                                </div>
                                <div>
                                  <v-icon
                                      medium
                                      right
                                      class="ml-5"
                                  >
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                </div>
                              </button>
                            </template>
                          </VueDatePicker>
                        </template>
                      </div>
                      <div class="mt-5">
                        <label>Автор</label>
                        <v-text-field
                            v-model="saleInfo.sales.user.name"
                            label="Автор"
                            outlined
                            readonly
                            dense
                            style="height: 48px;margin-top: 10px"
                            class="rounded-lg"
                        ></v-text-field>
                      </div>
                      <div class="mt-5">
                        <label>Организация</label>
                        <v-select
                            v-if="(type === 'exist' || type === 'info') && saleInfo && saleInfo.sales.org"
                            v-model="saleInfo.sales.org"
                            :items="listOrganizations.sales"
                            item-value="id"
                            item-text="name"
                            class="rounded-lg"
                            placeholder="Организация"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            return-object
                            style="height: 48px;margin-top: 10px"
                        ></v-select>
                        <v-select
                            v-else
                            v-model="saleInfo.sales.org.name"
                            :items="listCashbox"
                            item-value="inn"
                            item-text="legal_entity"
                            class="rounded-lg"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            style="height: 48px;margin-top: 10px"
                        ></v-select>
                      </div>

                      <div class="mt-5">
                        <v-btn
                            v-if="type !== 'info' && type === 'exist' && saleInfo"
                            class="button__secondary button__secondary-text"
                            style="width: 100% !important;"
                            @click="changeToEdit"
                        >
                          Редактировать продажу <v-icon
                            dark
                            right
                            small
                        >
                          mdi-file-edit-outline
                        </v-icon>
                        </v-btn>
                      </div>
                    </v-sheet>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
              <v-col
                  :cols="(type === 'new') || (type === 'exist' && sale_tab === 1) || (type === 'info' && sale_tab === 1) || (type === 'edit') ? 8 : 12"
                  style="position: relative"
              >


              <v-row style="position:relative;">
         
                <v-col
                  :style="(type === 'info' || type === 'exist') ? 'position: relative;' : 'position:fixed; width:45%;'"
                >

                <v-row v-if="showHeaderNew" style="margin-bottom:20px;">
                  <v-col cols="12">
                    
                    <v-sheet
                        max-height="80px"
                        rounded="lg"
                        class="d-flex justify-space-between align-center card"
                    >
                      <div v-if="client && client.name">
                        {{ client && client.name }}
                      </div>
                      <div v-else>
                        {{ client.last_name}} {{client.first_name }}
                      </div>
                      <v-tabs
                          centered
                          id="horizontal_tabs"
                          v-model="sale_tab"
                          class="d-flex align-center sale__tab"
                      >
                        <v-tab
                            v-for="item in sales"
                            :key="item.tab"
                            class="ml-4"
                        >
                          {{ item.tab }}
                        </v-tab>
                      </v-tabs>
                    </v-sheet>
                  </v-col>
                </v-row>

                <v-skeleton-loader
                  v-if="isLoadingSale"
                  type="table"
                >

                </v-skeleton-loader>

       
                <v-sheet rounded="lg" class="card" style="width: 100%; padding: 0 !important;" v-else>
                  <div class="d-flex justify-space-between" style="padding: 20px 20px 0 20px">
                    <div style="display:flex; align-items: center;">
                      <v-btn
                          class="button__lighten"
                          :disabled="((type === 'edit' || type === 'exist') ? saleInfo.sales.buy_list.length === 0 : nomenclatures.length === 0) || isLoadingSale"
                          @click="saveSale"
                      >
                        <img src="/playground_assets/save-logo.svg" class="mr-1" alt="">
                        Сохранить
                      </v-btn>
                      <v-btn
                          v-if="type === 'new'"
                          class="button__lighten ml-3"
                          :disabled="(type === 'new' ? nomenclatures.length === 0 : nomenclatures.length === 0) || isLoadingSale"
                          @click="printSaleBuy"
                      >
                        <img src="/playground_assets/printer-logo.svg" class="mr-1" alt="">
                        Печать
                      </v-btn>
                      <v-btn
                          v-if="type === 'edit' || type === 'info' || type === 'exist'"
                          class="button__lighten ml-3"
                          :disabled="((type === 'edit' || type === 'info' || type === 'exist') ? saleInfo.sales.buy_list.length === 0 : nomenclatures.length === 0) || isLoadingSale"
                          @click="printSale"
                      >
                        <img src="/playground_assets/printer-logo.svg" class="mr-1" alt="">
                        Печать
                      </v-btn>
                      <v-btn
                          :to="{ name: 'SaleHistoryNew', params: { client: client, buy_id: buy_id } }"
                          class="button__lighten ml-3"
                          :disabled="type === 'new'"
                      >
                        <img src="/playground_assets/clock-logo.svg" class="mr-1" alt="">
                        История
                      </v-btn>

                      <div v-if="saleInfo && saleInfo.sales && saleInfo.sales.id" style="margin-left:20px;">
             
                        <!-- <div v-if="!saleInfo.sales.deletion" @click="buyDeletion(saleInfo.sales.deletion)" style="cursor: pointer;">
                          Пометить на удаление
                        </div> -->
                          <v-btn
                          v-if="!saleInfo.sales.deletion"
                          @click="buyDeletion(saleInfo.sales.deletion)"
                                class="button__lighten ml-3"
                            >
                              <v-icon small class="mr-2">mdi-trash-can-outline</v-icon>
                              Удалить
                            </v-btn>

                        <div @click="buyDeletion(saleInfo.sales.deletion)" style="cursor: pointer;" v-else>
                          Снять пометку на удаление
                        </div>
                      </div>

                      <div v-else-if="buy_id_payment && buy_id_payment.length > 6" style="margin-left:20px;">
             
                        <!-- <div v-if="!saleInfo.sales.deletion" @click="buyDeletion(saleInfo.sales.deletion)" style="cursor: pointer;">
                          Пометить на удаление
                        </div> -->
                          <v-btn
                          @click="buyDeletion2(buy_id_payment)"
                                class="button__lighten ml-3"
                            >
                              <v-icon small class="mr-2">mdi-trash-can-outline</v-icon>
                              Удалить
                            </v-btn>

              
                      </div>


                    </div>

                    <div>
                      <v-menu
                          bottom
                          left
                          offset-y
                          rounded="lg"
                          content-class="custom__menu"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="button__lighten ml-3"
                          >
                            <v-icon
                                small
                                class="mr-1"
                            >
                              mdi-swap-vertical
                            </v-icon>
                            Сортировать
                          </v-btn>
                        </template>

                        <v-list>
                          <v-list-item
                          >
                            <v-list-item-title @click="sortDesc = false" style="cursor: pointer">По возрастанию</v-list-item-title>
                          </v-list-item>
                          <v-list-item
                          >
                            <v-list-item-title @click="sortDesc = true" style="cursor: pointer">По убыванию</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </div>

                  <v-data-table
                      v-if="type === 'exist' || type === 'edit' || type === 'info'"
                      :headers="type === 'edit' ? headersNomenclature : headersExistNomenclature"
                      :items="saleInfo.sales.buy_list"
                      :hide-default-footer="true"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      item-key="name"
                      class="elevation-1 mt-3 rounded-b-0 custom__table"
                  >
                  <template v-slot:item.service.name="{ item }">
                    {{  item.service.name }} 
                    <div v-if="item.marking_is_used" style="font-weight:bold;">(M)</div>
     
                    <!-- <div v-if="item.activation_date " style="    display: flex;
                          align-items: center;
                          padding: 10px 0px 20px 10px;
                          border-top: 1px solid #e0e0e0;
                          margin-left: -13px;
                          margin-top: 20px;
                          margin-right: -14px;">
                       <div style="display:flex; align-items:center; justify-content:center; width:120px; height:30px; background-color: #eee; border-radius:20px;">
                        Дата активации
                      </div>
                       <div style="margin-left:10px;">
                        {{ item.activation_date.split('T')[0]}}
                      </div>
                    </div> -->

                    <div v-if="item.activation_date" style="    display: flex;
                        align-items: center;
                        padding: 10px 0px 20px 10px;
                        border-top: 1px solid #e0e0e0;
                        margin-left: -13px;
                        margin-top: 20px;
                        margin-right: -14px;">
                       <div style="display:flex; align-items:center; justify-content:center; width:120px; height:30px; background-color: #eee; border-radius:20px;">
                        Дата активации 
                      </div>
                       <div >
                 

                          <template v-if="item.activation_date !== '111'">
                            <VueDatePicker
                                
                                no-title
                                no-calendar-icon
                                no-header
                                color="#629f34"
                                v-model="item.activation_date"
                                :visible-years-number="124"
                                format="DD.MM.YY"
                            >
                              <template #activator="{ date }">
                                <button
                                    class="button custom__datepicker2"
                                    ref="activator"
                                    type="button"
                                >
                                  <div>
                                    <span v-if="date">{{ date }}</span>
                                    <span v-else style="color: gray">Нет даты</span>
                                  </div>
                         
                                </button>
                              </template>
                            </VueDatePicker>

                     
                          </template>

                          <template v-else>
                            <VueDatePicker
                                
                                no-title
                                no-calendar-icon
                                no-header
                                color="#629f34"
                                v-model="item.activation_date_new"
                                :visible-years-number="124"
                                format="DD.MM.YY"
                            >
                              <template #activator="{ date }">
                                <button
                                    class="button custom__datepicker2"
                                    ref="activator"
                                    type="button"
                                >
                                  <div>
                                    <span v-if="date">{{ date }}</span>
                                    <span v-else style="color: gray">Нет даты</span>
                                  </div>
                         
                                </button>
                              </template>
                            </VueDatePicker>

                     
                          </template>
                      </div>
                    </div>

                    <div v-else-if="item.activation_type && item.activation_type.split('при пр')[1]" style="    display: flex;
                        align-items: center;
                        padding: 10px 0px 20px 10px;
                        border-top: 1px solid #e0e0e0;
                        margin-left: -13px;
                        margin-top: 20px;
                        margin-right: -14px;">
                      <div style="display:flex; align-items:center; justify-content:center; width:120px; height:30px; background-color: #eee; border-radius:20px;">
                        Дата активации
                      </div>
                       <div style="margin-left:10px;">
                        Нет даты
                      </div>
                    </div>

                  </template>
                    <template v-slot:item.price="{ item }">
                      {{ item.price === 0 ? 'беспл.' : item.price }}
                    </template>
                    <template v-slot:item.vat="{ item }">
                      <div v-if="item.vat && item.vat.id && item.vat.count" style="display:flex; flex-direction:column;">
                        <div v-if="item.vat.name"> {{ item.vat.name }}</div>
                        <div>
                          {{ ((item.price*item.vat.count)/(100+item.vat.count)).toFixed(2) }} р.
                        </div>
                      </div>
                      <div v-else> Без НДС</div>
                    </template>
                    <template v-slot:item.aa="{ item }">
                        <!-- <span>{{item.specialist.name}}</span> -->
                                        <div style="display: flex; align-items: center;">
                                          <v-select
                                              class="rounded-lg custom__select"
                                              v-model="item.specialist.id"
                                              :items="(specialist && specialist.specialist && specialist.specialist.length > 0) ? specialist.specialist : specialist_def"
                                              item-value="id"
                                              item-text="name"
                                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '150' }"
                                              placeholder="Выбрать"
                                              append-icon="mdi-chevron-down"
                                              outlined
                                              dense
                                              style="height: 48px;margin-top: 10px; max-width: 200px; width: 200px">
                                          </v-select>
                                          <!-- <span hidden>{{item.price}}</span> -->

                                          <span style="cursor:pointer; color:red;" v-if="item.specialist_id" @click="item.specialist_id = null"> X </span>
                                          <span style="cursor:pointer; color:red;" v-if="item.specialist && item.specialist.id" @click="item.specialist.id = null"> X </span>
                                        </div>
                    </template>
                    <template v-if="type === 'edit'" v-slot:item.count="{ item }">
                      <div class="d-flex justify-space-between">
                        <div class="logo-bg" @click="subtractCountNomenclature(item)">
                          <img src="/playground_assets/minus-circle-logo.svg" alt="">
                        </div>
                        <div>{{ item.count }}</div>
                        <div class="logo-bg" @click="addCountNomenclature(item)">
                          <img src="/playground_assets/smallpluscircle3282-42rl.svg" alt="">
                        </div>
                      </div>
                    </template>
                    <template v-if="type === 'edit'" v-slot:item.discount="{ item }">
                      <v-text-field
                          v-model="item.discount"
                          type="number"
                          min="0"
                          max="100"
                          hide-spin-buttons
                          style="padding: 0 !important; font-size: 14px"
                          flat
                          solo
                          hide-details
                      ></v-text-field>
                    </template>
                    <template v-if="type === 'edit'" v-slot:item.total="{ item }">
                      {{ item.total = (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count }}
                    </template>
                    <template v-slot:item.sale_manager="{ item }">
                                        <div style="display: flex; align-items: center;">
                                          <v-select
                                              class="rounded-lg custom__select"
                                              v-model="item.manager.id"
                                              :items="specialist_def ? specialist_def : []"
                                              item-value="id"
                                              item-text="name"
                                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '150' }"
                                              placeholder="Менеджер"
                                              append-icon="mdi-chevron-down"
                                              outlined
                                              dense
                                              style="height: 48px;margin-top: 10px; max-width: 200px; width: 200px">
                                          </v-select>
                                          <!-- <span hidden>{{item.price}}</span> -->

                                          <span style="cursor:pointer; color:red;" v-if="item.manager_id" @click="item.manager_id = null"> X </span>
                                          <span style="cursor:pointer; color:red;" v-if="item.manager && item.manager.id" @click="item.manager.id = null"> X </span>
                                        </div>
                    </template>
                    <template v-if="type === 'edit'" v-slot:item.actions="{ item }">
                      <div class="logo-bg" @click="deleteFromNomenclature(item)"><img src="/playground_assets/trash-logo.svg" alt=""></div>
                    </template>

                    <template v-slot:body.append>
                      <tr>
                        <td colspan="12">
                          <div class="d-flex justify-space-between total-price">
                            <span>Итого с НДС</span>
                            <span>{{ type === 'edit' ?  saleInfo.sales.buy_list.reduce((res, i) => res + i.total, 0) : saleInfo.sales.summ }} ₽</span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="12">
                          <div class="d-flex justify-space-between total-price">
                            <span>Итого</span>
                            <span>{{ type === 'edit' ?  saleInfo.sales.buy_list.reduce((res, i) => res + i.total, 0) : saleInfo.sales.summ }} ₽</span>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>


                  <v-data-table
                      v-if="type === 'new'"
                      :headers="headersNomenclature"
                      :items="nomenclatures"
                      no-data-text="Нет добавленных услуг и пакетов"
                      :hide-default-footer="true"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      item-key="name"
                      class="elevation-1 mt-3 rounded-b-0 custom__table"
                  >
                  <template v-slot:item.service.name="{ item }">
                    {{  item.service.name }} 
                    <div v-if="item.marking_is_used" style="font-weight:bold;">(M)</div>
   
                    <div v-if="item.activation_date && !item.activation_date.split('001-')[1]" style="    display: flex;
    align-items: center;
    padding: 10px 0px 20px 10px;
    border-top: 1px solid #e0e0e0;
    margin-left: -13px;
    margin-top: 20px;
    margin-right: -14px;">
                       <div style="display:flex; align-items:center; justify-content:center; width:120px; height:30px; background-color: #eee; border-radius:20px;">
                        Дата активации
                      </div>
                       <div style="margin-left:10px;">
                        {{ item.activation_date }}
                      </div>
                    </div>

                    <div v-else-if="item.activation_type && item.activation_type.split('при пр')[1]" style="    display: flex;
    align-items: center;
    padding: 10px 0px 20px 10px;
    border-top: 1px solid #e0e0e0;
    margin-left: -13px;
    margin-top: 20px;
    margin-right: -14px;">
                       <div style="display:flex; align-items:center; justify-content:center; width:120px; height:30px; background-color: #eee; border-radius:20px;">
                        Дата активации 
                      </div>
                       <div >
                 

                          <template>
                            <VueDatePicker
                                no-title
                                no-calendar-icon
                                no-header
                                color="#629f34"
                                v-model="item.activation_date_new"
                                format="DD.MM.YY"
                            >
                              <template #activator="{ date }">
                                <button
                                    class="button custom__datepicker2"
                                    ref="activator"
                                    type="button"
                                >
                                  <div>
                                    <span v-if="date">{{ date }}</span>
                                    <span v-else style="color: gray">Нет даты</span>
                                  </div>
                         
                                </button>
                              </template>
                            </VueDatePicker>
                          </template>
                      </div>
                    </div>

                    <div v-if="item.marking_is_used">
                            <br>
                            <span v-if="!item.marking_code" style="font-weight:bold;">
                            Qr - код контрольной марки:
                            </span>
                            <span v-else style="font-weight:bold;">
                              {{item.marking_code}}
                            </span>
                          </div>

                  </template>
                    <template v-slot:item.price="{ item }">

                      
                      {{ item.price === 0 ? 'беспл.' : item.price }}
                    </template>
                    <template v-slot:item.vat="{ item }">
                      <div v-if="item.vat && item.vat.id && item.vat.count" style="display:flex; flex-direction:column;">
                        <div v-if="item.vat.name"> {{ item.vat.name }}</div>
                        <div>
                          {{ item.discount ? (((item.price - (item.price * (item.discount / 100)))*item.vat.count)/(100+item.vat.count)).toFixed(2) : ((item.price*item.vat.count)/(100+item.vat.count)).toFixed(2) }} р.
                        </div>
                      </div>
                    </template>
                    <template v-slot:item.count="{ item }">
                      <div class="d-flex justify-space-between">
                        <div class="logo-bg" @click="subtractCountNomenclature(item)" v-if="!noCountServices[item.type]">
                          <img src="/playground_assets/minus-circle-logo.svg" alt="">
                        </div>
                        <div>{{ item.count }}</div>
                        <div class="logo-bg" @click="addCountNomenclature(item)" v-if="!noCountServices[item.type]">
                          <img src="/playground_assets/smallpluscircle3282-42rl.svg" alt="">
                        </div>
                      </div>
                    </template>
                    <template v-slot:item.discount="{ item }">
                      <v-text-field
                          v-model="item.discount"
                          type="number"
                          min="0"
                          max="100"
                          hide-spin-buttons
                          style="padding: 0 !important; font-size: 14px"
                          flat
                          solo
                          hide-details
                      ></v-text-field>
                    </template>
                    <template v-slot:item.total="{ item }">
                      {{ item.total = (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count }}
                    </template>
                    <template v-slot:item.aa="{ item }">
                                        <div style="display: flex; align-items: center;">
                                          <v-select
                                              class="rounded-lg custom__select"
                                              v-model="item.specialist_id"
                                              :items="(specialist && specialist.specialist && specialist.specialist.length > 0) ? specialist.specialist : specialist_def"
                                              item-value="id"
                                              item-text="name"
                                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '150' }"
                                              placeholder="Выбрать"
                                              append-icon="mdi-chevron-down"
                                              outlined
                                              dense
                                              style="height: 48px;margin-top: 10px; max-width: 150px; width: 150px">
                                          </v-select>
                                          <!-- <span hidden>{{item.price}}</span> -->

                                          <span style="cursor:pointer; color:red;" v-if="item.specialist_id" @click="item.specialist_id = null"> X </span>
                                        </div>
                    </template>
                    <template v-slot:item.sale_manager="{ item }">
                                        <div style="display: flex; align-items: center;">
                                          <v-select
                                              class="rounded-lg custom__select"
                                              v-model="item.manager_id"
                                              :items="specialist_def ? specialist_def : []"
                                              item-value="id"
                                              item-text="name"
                                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '150' }"
                                              placeholder="Менеджер"
                                              append-icon="mdi-chevron-down"
                                              outlined
                                              dense
                                              style="height: 48px;margin-top: 10px; max-width: 150px; width: 150px">
                                          </v-select>
                                          <!-- <span hidden>{{item.price}}</span> -->

                                          <span style="cursor:pointer; color:red;" v-if="item.manager_id" @click="item.manager_id = null"> X </span>
                                        </div>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <div class="logo-bg" @click="deleteFromNomenclature(item)"><img src="/playground_assets/trash-logo.svg" alt=""></div>
                    </template>
          
                    <template v-slot:body.append>
                      <tr>
                        <td colspan="12">
                          <div class="d-flex justify-space-between total-price">
                            <span>Итого с НДС</span>
                            <span>{{ nomenclatures.reduce((res, i) => res + i.total, 0) }} ₽</span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="12">
                          <div class="d-flex justify-space-between total-price">
                            <span>Итого</span>
                            <span>{{ nomenclatures.reduce((res, i) => res + i.total, 0) }} ₽</span>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>

                  <div v-if="rentalArray && rentalArray.length > 0" >

                    <h4 style="margin:20px 0px 20px 20px;"> Аренды: </h4>

                    <v-data-table
                        :headers="headersRentals"
                        :items="rentalArray"
                        no-data-text="Нет добавленных аренд"
                        :hide-default-footer="true"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        item-key="name"
                        class="elevation-1 mt-3 rounded-b-0 custom__table"
                    >
        
                      <template v-slot:item.total="{ item }">
                        {{ item.price }}
                      </template>
            
                      <template v-slot:item.actions="{ item }">
                        <div class="logo-bg" @click="deleteFromNomenclature(item,true)"><img src="/playground_assets/trash-logo.svg" alt=""></div>
                      </template>
            
                      <template v-slot:body.append>
                        <tr>
                          <td colspan="12">
                            <div class="d-flex justify-space-between total-price">
                              <span>Итого с НДС</span>
                              <span>{{ rentalArray.reduce((res, i) => res + i.total, 0) }} ₽</span>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="12">
                            <div class="d-flex justify-space-between total-price">
                              <span>Итого</span>
                              <span>{{ rentalArray.reduce((res, i) => res + i.total, 0) }} ₽</span>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                  </div>

                  <div v-if="type !== 'info' && !rentaItemDialog" class="d-flex justify-space-between" style="padding: 20px">

                    <div style="width:100px;">
                      <v-btn class="button__secondary button__secondary-text" @click="buyerSaleOpen()">
                        Оплата от покупателя (безналичная)
                      </v-btn>
                    </div>
                             <!-- <v-btn class="button__secondary button__secondary-text">
                        Оплата от покупателя (Безналичная)
                      </v-btn> -->
                      
                    <!-- <div v-if="(saleInfo && saleInfo.sales) && type !== 'new'">
             
                      <div v-if="!saleInfo.sales.deletion" @click="buyDeletion(saleInfo.sales.deletion)" style="cursor: pointer;">
                        Пометить на удаление
                      </div>
                      <div @click="buyDeletion(saleInfo.sales.deletion)" style="cursor: pointer;" v-else>
                        Снять пометку на удаление
                      </div>
                    </div> -->

                     <!-- 
                    <div v-else-if="type === 'new' && buy_id_payment">
                     <v-btn class="button__secondary button__secondary-text">
                        Оплата от покупателя (Безналичная)
                      </v-btn> -->
                      <!-- <div v-if="!saleInfo.sales.deletion" @click="buyDeletion(saleInfo.sales.deletion)" style="cursor: pointer;">
                        Пометить на удаление
                      </div>
                      <div @click="buyDeletion(saleInfo.sales.deletion)" style="cursor: pointer;" v-else>
                        Снять пометку на удаление
                      </div>
                    </div>  
                     -->
                    <div style="display:flex; align-items:center; ">

                      <!-- <router-link 
                      v-if="(saleInfo && saleInfo.sales) && type !== 'new'"
                      style="margin-right:10px;" :to="{name: 'ReturnServiceDetail', params: {client: client, buy: item, date: date}}">
                        Возврат/Отмена
                      </router-link> -->

                      <!-- <div v-if="(saleInfo && saleInfo.sales) && type !== 'new'" style="cursor:pointer; position:relative; margin-right:10px;" @click="returnModal = !returnModal">
                        Возврат / Отмена

                        <div v-if="returnModal" style="position:absolute; bottom:-50px; width:100px; background:white; padding:5px 10px; display:flex; flex-direction: column;">
                            <router-link 
                            style="margin-right:10px;" :to="{name: 'ReturnServiceDetail', params: {client: client, buy: item, date: date}}">
                              Возврат
                            </router-link>
                            <router-link 
                            style="margin-right:10px;" :to="{name: 'ReturnServiceDetail', params: {client: client, buy: item, date: date}}">
                              Отмена
                            </router-link>
                        </div>
                      </div> -->

                      <!-- <router-link 
                      v-else-if="type === 'new' && buy_id_payment"
                      style="margin-right:10px;" :to="{name: 'ReturnServiceDetail', params: {client: client, buy: item, date: date}}">
                        Возврат/Отмена
                      </router-link> -->

                      <div v-if="nomenclatures.length > 0 && type === 'new'" style="display:flex; align-items: center;">
                        <div>Промокод:</div>
                        <div><v-icon v-if="!pay_promo_setted && (pay_promo && pay_promo.length > 0)" @click="setPromo()">mdi-check-circle-outline</v-icon></div>
                        <div>
                          <v-text-field
                                  v-model="pay_promo"
                                  outlined
                                  dense
                                  style="height: 35px;width:100px; margin:0px 5px;"
                                  class="rounded-lg"
                              ></v-text-field>
                        </div>
                        <div v-if="pay_promo && pay_promo.length > 0" style="cursor:pointer; margin-right:30px;" @click="clearPromo()"> X </div>
                      </div>
                      
                      <v-btn v-if="nomenclatures.length === 0 && type === 'new'" class="button__secondary button__secondary-text">
                        Оплатить 
                      </v-btn>
                      <v-btn v-else-if="nomenclatures.length > 0" class="button__success" :disabled="isLoadingSale" @click="modalPayment">
                        Оплатить
                      </v-btn>
                    </div>
                    <div class="button__success" v-if="rentalArray && rentalArray.length > 0" @click=saveRental>
                        Сохранить аренды
                    </div>

                  </div>
                  
                  <div v-if="type === 'info' || type === 'exist' && !rentaItemDialog" class="d-flex justify-space-between" style="padding: 20px">
                      <!-- <router-link 
                      v-if="(saleInfo && saleInfo.sales) && type !== 'new'"
                      style="margin-right:10px;" :to="{name: 'ReturnServiceDetail', params: {client: client, buy: saleInfo.sales, date: saleInfo.sales.date}}">
                        Возврат/Отмена
                      </router-link> -->

                      <div v-if="(saleInfo && saleInfo.sales) && type !== 'new'" style="cursor:pointer; position:relative; margin-right:10px;" @click="returnModal = !returnModal">
                        Возврат / Отмена

                        <div v-if="returnModal" style="position:absolute; bottom:-50px; width:100px; background:white; padding:5px 10px; display:flex; flex-direction: column; box-shadow:0px 0px 0px 0px rgb(0 0 0 / 20%), 0px 0px 0px 0px rgb(0 0 0 / 14%), 0px 0px 0px 0px rgb(0 0 0 / 12%);">
                            <router-link 
                            style="margin-right:10px;" :to="{name: 'ReturnService', params: {client: client, buy: saleInfo.sales, datebuy: saleInfo.sales.date}}">
                              Возврат
                            </router-link>
                            <router-link 
                              v-if="saleInfo.sales.pays && saleInfo.sales.pays.length > 0"
                            style="margin-right:10px;" :to="{name: 'ReturnCancelPayment', params: {client: client, buy: saleInfo.sales, datebuy: saleInfo.sales.date}}">
                              Отмена
                            </router-link>
                        </div>

             
                      </div>

                        <div v-if="(saleInfo && saleInfo.sales && saleInfo.sales.pays) && type !== 'new'" style="display:flex; align-items:center; flex-direction: column;">
                            <div v-for="pay in saleInfo.sales.pays" :key="pay.id">
                              <span v-if="pay && pay.name && pay.type === 3" style="background:#55bb55;"> <b> ({{ pay.sum_in }} руб.) </b> {{ pay.name }}</span>
                              <span v-if="pay && pay.name && pay.type === 1" style="background:yellow;"><b> ({{ pay.sum_in }} руб.)</b> {{ pay.name }}</span>
                              <span v-if="pay && pay.name && pay.type === 2" style="background:#f7c52d;"><b> ({{ pay.sum_in }} руб.)</b> {{ pay.name }}</span>

                              <span v-if="pay && pay.name && pay.type === 5 || !pay.type" style="background:#e6e3e3; cursor:pointer;" @click="detailBuyer(pay)"><b> ({{ pay.sum_in }} руб.)</b> {{pay.name}}</span>

                            </div>
                        </div>

                        <div v-if="type === 'exist'" style="
                            width: 50%;
                          display: flex;
                          align-items: center;
                          justify-content: end;
                        ">
                          <div v-if="(nomenclatures.length > 0) || (saleInfo && saleInfo.sales.buy_list && saleInfo.sales.buy_list.length > 0)" style="display:flex; align-items: center;">
                            <div>Промокод:</div>
                            <div><v-icon v-if="!pay_promo_setted && (pay_promo && pay_promo.length > 0)" @click="setPromo()">mdi-check-circle-outline</v-icon></div>
                            <div>
                              <v-text-field
                                      v-model="pay_promo"
                                      outlined
                                      dense
                                      style="height: 35px;width:100px; margin:0px 5px;"
                                      class="rounded-lg"
                                  ></v-text-field>
                            </div>
                            <div v-if="pay_promo && pay_promo.length > 0" style="cursor:pointer; margin-right:30px;" @click="clearPromo()"> X </div>
                          </div>
                          
                    
                          <v-btn v-if="(nomenclatures.length > 0) || (saleInfo && saleInfo.sales.buy_list && saleInfo.sales.buy_list.length > 0)" class="button__success" :disabled="isLoadingSale" @click="modalPayment">
                            Оплатить
                          </v-btn>
                          <v-btn v-else-if="(nomenclatures.length === 0) || (saleInfo && saleInfo.sales.buy_list && saleInfo.sales.buy_list.length === 0)" class="button__secondary button__secondary-text">
                            Оплатить 
                          </v-btn>
                        </div>

                  </div>
                  <!-- <div v-if="type === 'info' && !rentaItemDialog" class="d-flex justify-space-between" style="padding: 20px">
                    <div v-if="(saleInfo && saleInfo.sales) || buy_id_payment">
                        <div v-if="!saleInfo.sales.deletion" @click="buyDeletion(saleInfo.sales.deletion)" style="cursor: pointer;">
                          Пометить на удаление
                        </div>
                        <div @click="buyDeletion(saleInfo.sales.deletion)" style="cursor: pointer;" v-else>
                          Снять пометку на удаление
                        </div>
                      </div>
                  </div> -->
                </v-sheet>
              </v-col>
              </v-row>
            </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="dialogPayment2"
              persistent
              max-width="640px"
          >

              
            <v-card rounded="lg" >
     
              <v-card-title class="justify-space-between">
                  <div></div>
                  <div>
                    <h4>Оплата</h4>
                  </div>
                  <v-btn icon @click="checkClosePay" >
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </v-card-title>

              <v-card-text>
                  <v-container>
                    <v-form ref="form" @submit.prevent="makePaymentPart">
                      <div style="display:flex;">
        
                        <v-row class="d-flex mt-5" style="flex-direction: column;">
                          <div>Касса:
                            <span style="color:red;" v-if="!listCashbox || listCashbox.length == 0">Касса не подключена</span>
                            <span v-else>{{sale.org.legal_entity}} ({{sale.org.inn}}) </span>
                          </div>
                          <div v-if="listCashbox && sale.org">Организация:
                            <span>{{sale.org.legal_entity}} ({{sale.org.inn}})</span>
                          </div>
                          <div v-else>Организация:
                            <span v-if="saleOrg">{{saleOrg.name}} ({{ saleOrg.inn }})</span>
                            <span v-else style="color:red;">Организация не выбрана</span>
                          </div>
                        </v-row>
                      </div>
                      <v-row class="d-flex justify-space-between mt-5">
                        <div style="width: 10%; display: flex; align-items: center; justify-content: start">
                          <span class="payment-text">Чек на</span>
                        </div>
                        <div style="width: 90%">
                          <v-btn-toggle
                              v-model="check_to"
                              mandatory
                              background-color="white"
                              class="mx-4 rounded-lg"
                          >
                            <v-btn>
                              <v-icon
                                  small
                                  dark
                                  class="mr-2"
                              >
                                mdi-phone-incoming-outline
                              </v-icon>
                              Телефон
                            </v-btn>
                            <v-btn>
                              <v-icon
                                  small
                                  dark
                                  class="mr-2"
                              >
                                mdi-email-outline
                              </v-icon>
                              Эл. почту
                            </v-btn>
                          </v-btn-toggle>
                        </div>
                      </v-row>
                      <v-btn-toggle
                          v-model="dialogTypeOfPaymentPart"
                          mandatory
                          background-color="#FFFFFF"
                          class="rounded-lg"
                          multiple
                          style="margin-top: 40px; width: 100%; flex-direction: column;"
                      >
                        <div style="width:100%; border:1px solid #eee; margin-bottom: 5px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #eee;
                            height: 50px;
                        ">
                          <div style="cursor:pointer;" @click="toCashPay()">Наличные: </div>

                          <div v-if="ifCashPay" style="display:flex; align-items: center; margin-left:10px;">
                            <input v-if="!cash_in_part_setted" type="text" v-model="cash_in_part_pre" style="background-color: white; padding:5px; width:100px;" />
                            <input v-else type="text" v-model="cash_in_part_pre" style="background-color: #9e9e9e; padding:5px; width:100px;" disabled />
                            <div style="
                            width:30px; height:30px; cursor: pointer; margin-left:10px;border: 1px solid #9e9e9e;
                            display: flex;
                            align-items: center;
                            justify-content: center;" >
                              <div v-if="cash_in_part_setted" @click="setCashPart(false)">X</div>
                              <div v-else @click="setCashPart(true)">OK</div>
                            </div>
                          </div>

                        </div>

                        <div style="width:100%; border:1px solid #eee; margin-bottom: 5px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #eee;
                            height: 50px;
                        ">
                          <div style="cursor:pointer;" @click="toCardPay()">Платёжная карта: </div>

                          <div v-if="ifCardPay" style="display:flex; align-items: center; margin-left:10px;">
                            <input v-if="!card_part_setted" type="text" v-model="summ_card_part_pre" style="background-color: white; padding:5px; width:100px;" />
                            <input v-else type="text" v-model="summ_card_part_pre" style="background-color: #9e9e9e; padding:5px; width:100px;" disabled />
                            <div style="
                            width:30px; height:30px; cursor: pointer; margin-left:10px;border: 1px solid #9e9e9e;
                            display: flex;
                            align-items: center;
                            justify-content: center;" >
                              <div v-if="card_part_setted" @click="setCardPart(false)">X</div>
                              <div v-else @click="setCardPart(true)">OK</div>
                            </div>
                          </div>

                        </div>

                        <div style="width:100%; border:1px solid #eee;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #eee;
                            height: 60px;
                        ">
                          <div style="cursor:pointer;" @click="checkSumm">Лицевые счета: </div>

                            <div style="padding-top: 20px;">
                              <v-select
                              v-if="canAddSumm"
                                  v-model="main_bill_part_def"
                                  :rules="mainBillRules"
                                  :items="listBill ? listBill.list : []"
                                  :item-text="item=>`${item.deposit_name} ( ${item.deposit_balance} р.) ( ${item.deposit_id.substr(0, 3)} )`"
                                  return-object
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  color="#629F33"
                                  style="width:200px; margin:0px 10px;"
                              ></v-select>
                            </div>

                          </div>

                          <div style="display: flex; flex-direction: column;  margin-bottom: 5px;">

                            <div v-if="main_bill_part" style="display:flex; align-items: center; justify-content:center; background: #eee;">

                              <div>
                                {{ main_bill_part.deposit_name }}
                              </div>

                              <div style="display:flex; align-items: center; margin-left:10px;">
                                <input v-if="!bill_part_setted" type="text" v-model="summ_bill_part_pre" style="background-color: white; padding:5px; width:100px;" />
                                <input v-else type="text" v-model="summ_bill_part_pre" style="background-color: #9e9e9e; padding:5px; width:100px;" disabled />
                                <div style="
                                width:30px; height:30px; cursor: pointer; margin-left:10px;border: 1px solid #9e9e9e;
                                display: flex;
                                align-items: center;
                                justify-content: center;" >
                                  <div v-if="bill_part_setted" @click="setBillPart(false)">X</div>
                                  <div v-else @click="setBillPart(true)">OK</div>
                                </div>
                              </div>

                            </div>

                            <div v-if="main_bill_part2" style="display:flex; align-items: center; justify-content:center; background: #eee;">

                              <div>
                                {{ main_bill_part2.deposit_name }}
                              </div>

                              <div style="display:flex; align-items: center; margin-left:10px;">
                                <input v-if="!bill_part_setted2" type="text" v-model="summ_bill_part_pre2" style="background-color: white; padding:5px; width:100px;" />
                                <input v-else type="text" v-model="summ_bill_part_pre2" style="background-color: #9e9e9e; padding:5px; width:100px;" disabled />
                                <div style="
                                width:30px; height:30px; cursor: pointer; margin-left:10px;border: 1px solid #9e9e9e;
                                display: flex;
                                align-items: center;
                                justify-content: center;" >
                                  <div v-if="bill_part_setted2" @click="setBillPart2(false)">X</div>
                                  <div v-else @click="setBillPart2(true)">OK</div>
                                </div>
                              </div>

                            </div>

                          </div>

                        <div style="width:100%; border:1px solid #eee; margin-bottom: 5px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #eee;
                            height: 80px;
                        ">
                          <div style="cursor:pointer;" @click="checkSumm">Бонусные счета: </div>

                            <div style="padding-top: 20px;">
                              <v-select
                                  v-if="canAddSumm"
                                  v-model="main_bonus_part"
                                  :rules="mainBonusRules"
                                  :items="listBonus ? listBonus.list : []"
                                  :item-text="item=>`${item.bonus_name} ( ${item.bonus_balance} ; Лимит:  ${item.bonus_limit} )`"
                                  return-object
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  color="#629F33"
                                  style="width:200px; margin:0px 10px;"
                              ></v-select>
                            </div>

                            <div v-if="main_bonus_part" style="display:flex; align-items: center; margin-left:10px;">
                              <input v-if="!bonus_part_setted" type="text" v-model="summ_bonus_part_pre" style="background-color: white; padding:5px; width:100px;" />
                              <input v-else type="text" v-model="summ_bonus_part_pre" style="background-color: #9e9e9e; padding:5px; width:100px;" disabled />
                              <div style="
                              width:30px; height:30px; cursor: pointer; margin-left:10px;border: 1px solid #9e9e9e;
                              display: flex;
                              align-items: center;
                              justify-content: center;" >
                                <div v-if="bonus_part_setted" @click="setBonusPart(false)">X</div>
                                <div v-else @click="setBonusPart(true)">OK</div>
                              </div>
                            </div>

                        </div>

                      </v-btn-toggle>
                      <v-row style="margin:20px 0px;"><h3>Итого к оплате: {{ summ_part }}</h3></v-row>
                      <hr>
                      
                      <v-row style="margin:10px 0px;">
                        <v-row>
                            <v-col>
                              <label>К оплате</label>
                              <v-text-field
                                  v-model="summ_cash_part"
                                  type="number"
                                  outlined
                                  dense
                                  class="rounded-lg"
                                  color="success"
                                  readonly
                              >
                                <template v-slot:append>
                                  <span style="padding-top: 4px">₽</span>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col>
                              <label>Внесено</label>
                              <v-text-field
                                  v-model="cash_in_part"
                                  placeholder="0"
                                  type="number"
                                  hide-spin-buttons
                                  :rules="dialogTypeOfPayment === 0 ? (((+summ) > 0) ? cashInRules : cashInFreeRules) : []"
                                  outlined
                                  dense
                                  class="rounded-lg"
                                  color="#629F33"
                                  :readonly="(ifCashPay && !ifCardPay && !main_bonus_part && !main_bill_part && !main_bill_part2) ? false : true"
                              >
                                <template v-slot:append>
                                  <span style="padding-top: 4px">₽</span>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col>
                              <label>Сдача</label>
                              <v-text-field
                                  v-model="cash_out_part"
                                  type="number"
                                  hide-spin-buttons
                                  readonly
                                  outlined
                                  dense
                                  class="rounded-lg"
                                  color="#629F33"
                              >
                                <template v-slot:append>
                                  <span style="padding-top: 4px">₽</span>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                      </v-row>
      
                      <v-row>
                        <v-col>
                          <v-btn
                          v-if="!dialogTypeOfPaymentPart || dialogTypeOfPaymentPart.length < 2"
                              class="button button__success"
                              type="submit"
                              style="width: 100% !important; height: 48px !important;"
                              :disabled="isLoadingSale || isLoading || doingPayment"
                          >
                            Оплатить
                          </v-btn>
                          <v-btn
                          v-else
                              class="button button__success"
                              type="submit"
                              style="width: 100% !important; height: 48px !important;"
                              :disabled="isLoadingSale || isLoading || doingPayment"
                          >
                            Оплатить
                          </v-btn>
                          <v-btn
                              class="button button__danger"
                              @click="cancelReceipt"
                              style="width: 100% !important; height: 48px !important; border-radius: 12px !important;"
                              :disabled="!doingPayment"
                          >
                            Отмена операции
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
            </v-card>
          </v-dialog>

        </v-row>


        <!-- ------------------------------------------------------->

        <v-row justify="center">
          <v-dialog
              v-model="rentaItemDialog"
              persistent
              max-width="640px"
              :id ="'anything-' + rentaItemDialog"
          >

              
            <v-card rounded="lg" >
     
              <v-card-title class="justify-space-between">
                  <div></div>
                  <div>
                    <h4>Аренда</h4>
                  </div>
                  <v-btn icon @click="rentaItemDialog = false" >
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </v-card-title>

              <v-card-text>
                  <v-container>
                    <v-form ref="formRent" @submit.prevent="makeRental">
                      <div v-if="client && client.name" style="display:flex;">
        
                        <v-row class="d-flex mt-5" style="flex-direction: column;">
                          <div style="padding:16px; display:flex; align-items: center; width:100%; height:38px; border:1px solid #E0E0E0; border-radius:12px;">

                                <div class="user-avatar">
                                  <img
                                      :src="client.photo ? client.photo : '/playground_assets/mediumcamera3282-238l.svg'"
                                      :style="client.photo ? 'height: 24px; width: 24px; border-radius: 24px;' : 'height: 24px; width: 24px'"
                                  />
                                </div>
                                <div style="color:#000; font-size: 16px; line-height:24px; margin-left:20px;">
                                  {{ client.name }}
                                </div>

                            </div>
                        </v-row>
                      </div>
                      <v-row class="d-flex justify-space-between mt-5">
                        <div style="width: 50%; display: flex; align-items: start; flex-direction: column;">
                          <span class="" style="color:#000; font-size: 16px; line-height:24px;">Аренда</span>
                          <dIv style="padding:16px; display:flex; align-items: center; width:100%; height:38px; margin-top:16px;">
                              <v-select
                                  v-model="rentaItem"
                                  :items="rentaItemDef"
                                  :item-text="item=>`${item.name}`"
                                  return-object
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label=""
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  color="#629F33"
                                  style="margin:28px 0px 0px -15px;"
                                  @change="changeRental"
                              ></v-select>
                          </div>
                        </div>
                        <div style="width: 50%; display: flex; align-items: start; flex-direction: column;">
                          <span class="" style="color:#000; font-size: 16px; line-height:24px;">Тариф</span>
                          <dIv style="margin-top:16px; padding:16px; display:flex; align-items: center; width:100%; height:42px; border:1px solid #E0E0E0; border-radius:10px;">
                              {{ rentaItem.price }}
                          </div>
                        </div>
                      </v-row>
                       
                      <v-row class="d-flex justify-space-between mt-5">
                        <div style="width: 50%; display: flex; align-items: start; flex-direction: column;">
                          <span class="" style="color:#000; font-size: 16px; line-height:24px;">Арендуемый шкаф/ячейка</span>
                          <dIv style="padding:16px; display:flex; align-items: center; width:100%; height:38px; margin-top:16px;">
                              <v-select
                                  v-model="rentaItem.rental"
                                  :items="rentaItem.rental"
                                  :item-text="item=>`${item.type_locker_name}`"
                                  return-object
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label=""
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  color="#629F33"
                                  style="margin:28px 0px 0px -15px;"
                              ></v-select>
                          </div>
                        </div>
                        <div style="width: 50%; display: flex; align-items: start; flex-direction: column;" v-if="rentalsTypes && rentalsTypes.rental[0] && rentalsTypes.rental[0].name">
                          <span class="" style="color:#000; font-size: 16px; line-height:24px;">Номер</span>
                          <dIv 
                          style="margin-top:16px; padding:16px; display:flex; align-items: center; width:100%; height:42px; border:1px solid #E0E0E0; border-radius:10px; cursor:pointer;"
                           @click="rentaItemDialogNumber = true" 
                          >
                             <span v-if="chosedRentalType"> {{ chosedRentalType.name }}</span> 
                             <span v-else>
                              {{ rentalsTypes.rental[0].name }}
                             </span>
             
                          </div>
                        </div>
                        <div style="width: 50%; display: flex; align-items: start; flex-direction: column;" v-else>
                          <span class="" style="color:#000; font-size: 16px; line-height:24px;">Номер</span>
                          <dIv style="margin-top:16px; padding:16px; display:flex; align-items: center; width:100%; height:42px; border:1px solid #E0E0E0; border-radius:10px;">
                            нет доступных шкафчиков
                          </div>
                        </div>
                      </v-row>
                      <v-row class="d-flex justify-space-between mt-5" style="margin: 30px 0px 10px -10px !important;">
                        <span style="color:#000; font-size: 16px; line-height:24px; font-weight:bold;">Выдача</span>
                        </v-row>
                      <v-row class="d-flex justify-space-between mt-5">
                        <div style="width: 30%; display: flex; align-items: start; flex-direction: column;">
                          
                          <span class="" style="color:#000; font-size: 16px; line-height:24px;">Дата</span>
                          <dIv style="padding:16px; display:flex; align-items: center; width:100%; height:38px; margin-top:16px;">
                            <template>
                            <VueDatePicker
                                no-title
                                no-header
                                color="#629f34"
                                v-model="rentaItem.date_time_start"
                                @input="dateChange"
                                format="DD.MM.YYYY"
                            >
                            <template #activator="{ date }">
                              <button
                                  class="button custom__datepicker custom__datepicker44"
                                  ref="activator"
                                  type="button"
                              >
                                <div>
                                  <span v-if="date">{{ date }}</span>
                                </div>
                                <div>
                                  <v-icon
                                      medium
                                      right
                                      class="ml-5"
                                  >
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                </div>
                              </button>
                            </template>
                            </VueDatePicker>
                          </template>
                          </div>
                        </div>
                        <div style="width: 30%; display: flex; align-items: start; flex-direction: column;">
                          <span class="" style="color:#000; font-size: 16px; line-height:24px;">Время</span>
                          <dIv style="margin-top:16px; padding:16px; display:flex; align-items: center; width:100%; height:42px; ">

                              <v-text-field
                                v-model="rentaItem.date_time_end"
                                outlined
                                dense
                                style="height: 48px;margin-top: 10px; margin-left:-20px; width:100%;"
                                class="rounded-lg"
                                min="1"
                                max="12"
                            ></v-text-field>

                          </div>
                        </div>
                        <div style="width: 30%; display: flex; align-items: start; flex-direction: column;" >
                          <span class="" style="color:#000; font-size: 16px; line-height:24px;">Месяцев</span>
                          <dIv style="margin-top:16px; padding:16px; display:flex; align-items: center; width:100%; height:42px;" v-if="rentaItem && rentaItem.rental">

                            <v-text-field
                                class="rounded-lg"
                                v-model.number="rentaItem.rental.duration_of_action_def"
                                type="number"
                                hide-spin-buttons
                                name="end_age"
                                :rules="endAgeRules"
                                placeholder="Месяцев"
                                dense
                                outlined
                                readonly
                                style="min-height: 20px !important; height:20px !important; margin-left: -20px; margin-top:-20px; padding:0px;"
                            >
                              <template v-slot:append>
                                <v-btn-toggle style="margin-right: -12px" class="rounded-r-lg no-active__toggle">
                                  <v-btn @click="downEndAge"
                                         style="padding: 0 !important; min-width: 38px !important; margin-top: -7px;">
                                    <v-icon>mdi-chevron-down</v-icon>
                                  </v-btn>
                                  <v-btn @click="upEndAge"
                                         style="padding: 0 !important; min-width: 38px !important; margin-top: -7px;">
                                    <v-icon>mdi-chevron-up</v-icon>
                                  </v-btn>
                                </v-btn-toggle>
                              </template>
                            </v-text-field>

                            <!-- <vue-numeric-input  
                            @change="changeMonths"
                            v-if="rentaItem.rental.duration_of_action === 6"
                            v-model="rentaItem.rental.duration_of_action_def" :min="1" :max="120" :step="6"></vue-numeric-input>

                            <vue-numeric-input  
                            @change="changeMonths"
                            v-if="rentaItem.rental.duration_of_action === 1"
                            v-model="rentaItem.rental.duration_of_action_def" :min="1" :max="120" :step="1"></vue-numeric-input>

                            <vue-numeric-input  
                            @change="changeMonths"
                            v-if="rentaItem.rental.duration_of_action === 12"
                            v-model="rentaItem.rental.duration_of_action_def" :min="1" :max="120" :step="12"></vue-numeric-input> -->

                          </div>
                        </div>
                      </v-row>

                      <v-row class="d-flex justify-space-between mt-5" style="margin: 30px 0px 10px -10px !important;">
                        <span style="color:#000; font-size: 16px; line-height:24px; font-weight:bold;">Возврат</span>
                        </v-row>
                      <v-row class="d-flex justify-space-between mt-5">
                        <div style="width: 50%; display: flex; align-items: start; flex-direction: column;">
                          
                          <span class="" style="color:#000; font-size: 16px; line-height:24px;">Дата</span>
                          <dIv style="padding:16px; display:flex; align-items: center; width:100%; height:38px; margin-top:16px;">
                            <template>
                            <VueDatePicker
                                no-title
                                no-header
                                color="#629f34"
                                v-model="rentaItem.return_date"
                                format="DD.MM.YYYY"
                            >
                            <template #activator="{ date }">
                              <button
                                  class="button custom__datepicker custom__datepicker44"
                                  ref="activator"
                                  type="button"
                              >
                                <div>
                                  <span v-if="date">{{ date }}</span>
                                </div>
                                <div>
                                  <v-icon
                                      medium
                                      right
                                      class="ml-5"
                                  >
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                </div>
                              </button>
                            </template>
                            </VueDatePicker>
                          </template>
                          </div>
                        </div>
                        <div style="width: 50%; display: flex; align-items: start; flex-direction: column; ">
                          <span class="" style="color:#000; font-size: 16px; line-height:24px;">Время</span>
                          <dIv style="margin-top:16px; padding:16px; display:flex; align-items: center; width:100%; height:42px; ">

                              <v-text-field
                                v-model="rentaItem.return_time"
                                outlined
                                dense
                                style="height: 48px;margin-top: 10px; margin-left:-20px; width:100%;"
                                class="rounded-lg"
                                min="1"
                                max="12"
                            ></v-text-field>

                          </div>
                        </div>
            
                      </v-row>

                      <v-row>
                        <div style="width: 50%; display: flex; align-items: start; flex-direction: column; margin:20px 0px 40px 0px;">
                          <span class="" style="color:#000; font-size: 16px; line-height:24px;">Сумма</span>
                          <dIv style="margin-top:16px; padding:16px; display:flex; align-items: center; width:100%; height:42px; border:1px solid #E0E0E0; border-radius:10px;">
                              <span v-if="rentaItem.rental && !rentalFormLoading">{{ rentaItem.rental.summ }}</span>
                              <span v-else>Сумма</span>
                          </div>
                        </div>
            
                      </v-row>
                      
                      <v-row>
                        <v-col>
                          <v-btn
                              class="button button__success"
                              type="submit"
                              style="width: 100% !important; height: 48px !important;"
                              :disabled="isLoadingSale || isLoading || doingPayment"
                          >
                            Сохранить
                          </v-btn>
                         
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
            </v-card>
          </v-dialog>

        </v-row>

        <v-row justify="center">
          <v-dialog
              v-model="rentaItemDialogNumber"
              persistent
              max-width="640px"
          >

              
            <v-card rounded="lg" >
     
              <v-card-title class="justify-space-between">
                  <div></div>
                  <div>
                    <h4>Шкафы и ячейки</h4>
                  </div>
                  <v-btn icon @click="rentaItemDialogNumber = false" >
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </v-card-title>

              <v-card-text>
                  <v-container v-if="rentalsTypes && rentalsTypes.rental">
                    <div style="display:flex; flex-direction:column; border:1px solid #e0e0e0; border-radius: 5px;;">

                      <div style="display:flex; align-items: center; background-color: #e0e0e0; ">
                        <div style="width:50%; padding:10px; text-align: center; color:#000; font-weight:bold;"> Наименование</div>
                        <div style="width:50%; padding:10px; text-align: center; color:#000; font-weight:bold;"> Ключ</div>
                      </div>

                      <div 
                        
                        v-for="deal in rentalsTypes.rental" :key="deal.id"
                        :style="(chosedRentalType && deal.id === chosedRentalType.id) ? 'cursor:pointer; display:flex; align-items: center; background-color: #629F33; border: 1px solid #e0e0e0;' : 'cursor:pointer;display:flex; align-items: center; border: 1px solid #e0e0e0;'"
                        >
                          <div @click="chosedRentalType = deal" style="width:50%; padding:10px;" v-if="deal"> {{deal.name}}</div>
                          <div @click="chosedRentalType = deal" style="width:50%; padding:10px; border-left:1px solid #e0e0e0;"> </div>
                      </div>


                    </div>

                                   
                    <v-row 
                    style="    position: fixed;
    bottom: 100px;
    width: 585px;">
                        <v-col style="text-align: center;">
                          <v-btn
                              class="button button__success"
                              
                              style="width: 50% !important; height: 48px !important; margin-top:10px;"
                              :disabled="!chosedRentalType"
                              @click="rentaItem.rentalType = chosedRentalType, rentaItemDialogNumber = false"
                          >
                            Выбрать
                          </v-btn>
                         
                        </v-col>
                      </v-row>

                  </v-container>
                </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>


        <v-row justify="center">
          <v-dialog
              v-model="buyerSaleModal"
              persistent
              max-width="800px"
          >

              
            <v-card rounded="lg" >
     
              <v-card-title class="justify-space-between">
                  <div></div>
                  <div>
                    <h4>Оплата безналичными средствами (Создание)</h4>
                    <span>Ресепшен / Рабочий стол / Оплата безналичными средствами (Создание)</span>
                  </div>
                  <v-btn icon @click="buyerSaleModal = false" >
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </v-card-title>

              <v-card-text>
                  <v-container v-if="listBill">
                    <v-row class="d-flex justify-space-between mt-5">

                      <div style="width: 50%; display: flex; align-items: start; flex-direction: column;">
                          <span class="" style="color:#000; font-size: 16px; line-height:24px;">Вид средств</span>
                          <dIv style="margin-top:16px; padding:16px; display:flex; align-items: center; width:100%; height:42px; ">
                            <v-select
                                  v-model="buyer_sale_type"
                                  :items="buyer_sale_type_list ? buyer_sale_type_list : []"
                                  :item-text="item=>`${item.name}`"
                                  return-object
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  color="#629F33"
                                  style="width:200px; margin:0px 10px;"
                              ></v-select>
                          </div>
                        </div>

                        <div style="width: 50%; display: flex; align-items: start; flex-direction: column;">

                          <span class="" style="color:#000; font-size: 16px; line-height:24px;">Счёт</span>

                          <dIv style="padding:16px; display:flex; align-items: center; width:100%; height:38px; margin-top:16px;">
                            <v-select
                                  v-model="buyer_sale_main"
                                  :rules="mainBillRules"
                                  :items="listBill ? listBill.list : []"
                                  :item-text="item=>`${item.deposit_name} ( ${item.deposit_balance} р.) ( ${item.deposit_id.substr(0, 3)} )`"
                                  return-object
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  color="#629F33"
                                  style="width:200px; margin:0px 10px;"
                              ></v-select>
                          </div>
                        </div>
                   
                      </v-row>

                                   
                    <v-row 
                    style="    position: fixed;
                        bottom: 100px;
                      width: 585px;">
                        <v-col style="text-align: center;">
                          <v-btn
                              class="button button__success"
                              
                              style="width: 50% !important; height: 48px !important; margin-top:10px;"
                              :disabled="!chosedRentalType"
                              @click="rentaItem.rentalType = chosedRentalType, rentaItemDialogNumber = false"
                          >
                            Сохрнаить
                          </v-btn>
                         
                        </v-col>
                      </v-row>

                  </v-container>
                </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>

        <v-row justify="center">
          <v-dialog
  v-model="dataMatrixDialog"
  max-width="650px"
  persistent
>
  <v-card style="text-align:center;">

    <!-- Заголовок -->
    <v-card-title style="text-align:center; font-weight:bold;">
      Считать QR-код контрольной марки запаса
    </v-card-title>


    <v-card-text>
      

      <!-- Текущий товар -->
      <!-- <div
        v-if="currentMarkingItem"
        style="
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          padding: 15px;
          margin-bottom: 20px;
        "
      >

        <div
          style="
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 12px;
          "
        >
          {{ currentMarkingItem.service.name }}
        </div> -->


        <!-- <div style="margin-bottom: 5px;">
          Цена:
          <b>{{ currentMarkingItem.price }} ₽</b>
        </div>


        <div style="margin-bottom: 5px;">
          Количество:
          <b>{{ currentRequiredCount }}</b>
        </div>


        <div style="margin-bottom: 5px;">
          Сумма:
          <b>{{ currentMarkingItem.total }} ₽</b>
        </div>


        <div>
          Ставка НДС:
          <b>{{ currentMarkingItem.vat_count }}%</b>
        </div> -->

     <!-- </div> -->


      <!-- Прогресс -->
      <!-- <div
        v-if="currentMarkingItem"
        style="
          margin-bottom: 15px;
          font-size: 15px;
        "
      >

        Отсканировано:

        <b>
          {{ currentScannedCount }}
        </b>

        из

        <b>
          {{ currentRequiredCount }}
        </b>

      </div> -->


      <!-- Поле сканирования -->
      <v-text-field
        ref="dataMatrixInput"
        v-model="dataMatrixCode"
        label="Сканируйте Data Matrix код"
        placeholder="Наведите сканер на код"
        outlined
        dense
        autofocus
        :loading="scanningLoading"
        :disabled="scanningLoading"
        @keyup.enter="checkDataMatrix"
      />

      <v-snackbar v-model="snackbar" color="error" timeout="3000">
                            {{ snackbarText }}
                          </v-snackbar>



      <!-- Список уже отсканированных кодов -->
      <!-- <div
        v-if="currentScannedCodes.length"
        style="margin-top: 20px;"
      >

        <div
          style="
            font-weight: 500;
            margin-bottom: 8px;
          "
        >
          Отсканированные коды:
        </div>


        <div
          v-for="(code, index) in currentScannedCodes"
          :key="index"
          style="
            display: flex;
            align-items: center;
            padding: 8px 10px;
            background: #f5f5f5;
            border-radius: 5px;
            margin-bottom: 5px;
            word-break: break-all;
          "
        >

          <span style="margin-right: 8px;">
            {{ index + 1 }}.
          </span>

          <span>
            {{ code }}
          </span>

        </div>

      </div> -->


    


    </v-card-text>


    <!-- Нижняя панель -->
    <v-card-actions>


        <!-- Кнопка Применить -->
       
      <div style="display:flex; align-items:center; justify-content:center; width:100%;">
        <v-btn
          class="button button__success"
         
          @click="checkDataMatrix"
        >
          Применить
        </v-btn>

          <v-btn
          class="button button__lighten"
            @click="scanningItem = null, dataMatrixCode = '', dataMatrixDialog = false"
            style="margin-left:20px;"
          >
            Отмена
          </v-btn>
      </div>


    </v-card-actions>

  </v-card>
</v-dialog>
        </v-row>

      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {mapState} from "vuex";
import {salesActionTypes} from "@/store/modules/sale";
import {cashboxActionTypes} from "@/store/modules/cashbox";
import {getItem, setItem} from "../helpers/persistanceStorage";
import {billActionTypes} from "@/store/modules/bill";
import {dealsActionTypes} from "@/store/modules/deals";
import {lessonActionTypes} from "@/store/modules/lesson";
import { nomenclatureActionTypes } from "@/store/modules/nomenclature";

export default {
  name: "Sale",
  props: ['client','buy_id','type','for','deal'],
  components: {
    VueDatePicker,
    Header,
    Menu
  },
  data() {
    return {
      chosedRentalType:null,
      rentaItemDialogNumber:false,
      dialogPayment2:false,
      salePart:true,
      sale_org_changed:false,
      searchService: null,
      showServices: false,
      dialogPayment: false,
      dialogClient: false,
      dialogTypeOfPayment: null,
      dialogTypeOfPaymentPart:[0,1,2,3],
      sale_tab: null,
      cashbox: null,
      cashboxRules: [
        v => !!v || 'Нужно выбрать кассу'
      ],
      main_bill: null,
      main_bill_part_def:null,
      main_bill_part:null,
      main_bill_part2:null,
      mainBillRules: [
        v => !!v || 'Нужно выбрать лицевой счет',
        v => parseInt(v.bill_balance) !== 0 || 'Нулевой баланс счёта'
      ],
      mainBonusRules: [
        v => !!v || 'Нужно выбрать бонусный счет',
        v => parseInt(v.bonus_balance) !== 0 || 'Нулевой баланс счёта',
        //v => parseInt(v.bonus_limit) < this.summ_bonus_part_pre || 'Превышен лимит'
      ],
      sortBy: 'total',
      sortDesc: false,
      check_to: 0,
      cash_in: null,
      //v => parseInt(v) !== 0 || 'Введите внесенную сумму'
      cashInFreeRules: [
        v => (v >= 0) || 'Введите внесенную сумму'
      ],
      cashInRules: [
        v => (v >= 0) || 'Введите внесенную сумму',
        v => parseInt(v) !== 0 || 'Введите внесенную сумму',
        v => !!v || 'Введите сумму'
      ],
      cash_out: 0,
      cash_from_bill: 0,
      cash_in_part: 0,
      cash_out_part: 0,
      // summ_cash_part:null,
      // summ_card_part:null,
      //v => parseInt(v) !== 0 || 'Введите сумму',
      //v => !!v || 'Введите сумму',
      cashFromBillRules: [
        v => parseInt(v) <= this.main_bill?.deposit_balance || 'Введите сумму не больше Л/С'
      ],
      buy_id_payment: null,
      sales: [
        {tab: 'Номенклатура'},
        {tab: 'Дополнительно'}
      ],
      sale: {
        number: null,
        date: new Date(),
        org: null,
        promocode: null,
      },
      listCashboxDef:[
        {
            inn:"1650387117",
            legal_entity:"OOO",
            serial:"0010872001250"
        },
        {
            inn:"165038711733",
            legal_entity:"IP",
            serial:"0010872001250333"
        }
      ],
      listCashbox: JSON.parse(getItem('list-cashbox')) ?? null,
      headersNomenclature: [
        {text: 'Наименование', sortable: false, value: 'service.name'},
        {text: 'Кол-во', sortable: false, value: 'count'},
        {text: 'Цена', sortable: false, value: 'price'},
        {text: 'НДС', sortable: false, value: 'vat'},
        {text: 'Скидка', sortable: false, value: 'discount', width: '10%'},
        {text: 'Сумма', value: 'total'},
        {text: 'Исполнитель', sortable: false, value: 'aa'},
        {text: 'Менеджер', sortable: false, value: 'sale_manager'},
        {text: '', value: 'actions', sortable: false},
      ],
      headersExistNomenclature: [
        {text: 'Наименование', sortable: false, value: 'service.name'},
        {text: 'Кол-во', sortable: false, value: 'count'},
        {text: 'Цена', sortable: false, value: 'price'},
        {text: 'НДС', sortable: false, value: 'vat'},
        {text: 'Скидка', sortable: false, value: 'discount'},
        {text: 'Сумма', value: 'total'},
        {text: 'Исполнитель', sortable: false, value: 'aa'},
        {text: 'Менеджер', sortable: false, value: 'sale_manager'},
      ],
      headersRentals:[
        {text: 'Наименование услуги', sortable: false, value: 'name'},
        {text: 'Количество услуги', sortable: false, value: 'rental.duration_of_action_def'},
        {text: 'Номер шкафа/ячейки', sortable: false, value: 'rentalType.name'},
        {text: 'Дата и время начала аренды', sortable: false, value: 'date_time_start'},
        {text: 'Дата и время заверения аренды', sortable: false, value: 'return_date'},
        {text: 'Цена услуги', sortable: false, value: 'price'},
        {text: 'Всего', sortable: false, value: 'total'},
        {text: '', value: 'actions', sortable: false},
      ],
      nomenclatures: [],
      specialist_id:null,
      manager_id:null,
      caseSensitive:false,
      saleOrg:null,
      specialistDef:[
        {
          id:"1",
          name:"test1"
        },
        {
          id:"2",
          name:"test2"
        }
      ],
      myTree:[],
      cashboxTerminal:"f0eb54ae-0b16-11ec-a060-60e32700ce56",
      term_i:0,
      summ_cash_part:0,
      summ_card_part:0,
      summ_bill_part:0,
      summ_bill_part2:0,
      summ_part:0,
      main_bill_part_pre:0,
      summ_cash_part_pre:0,
      summ_card_part_pre:0,
      summ_bill_part_pre:0,
      summ_bill_part_pre2:0,
      cash_in_part_pre:0,
      cash_in_part_setted:false,
      card_part_setted:false,
      bill_part_setted:false,
      bill_part_setted2:false,
      bonus_part_setted:false,
      main_bonus_part:null,
      summ_bonus_part_pre:0,
      ifCardPay:false,
      ifCashPay:false,
      canAddSumm:false,
      buy_payment_list:null,
      rentaItemDialog:false,
      rentaItem:{},
      rentaItemDef:[
        {
          id:"e154f6f8-eced-11ea-812c-9c5c8e747603",
          name:"Аренда шкафчика на 6 месяцев (клевер)",
          price:4950,
          date_time_start:null,
          date_time_end:null,
          return_date:null,
          return_time:null,
          activation_type: "",
          rental_type: "Шкафы",
          rental: {
            type_locker_id: "c214ad10-f010-11ea-812c-9c5c8e747603",
            type_locker_name: "шкафы клевер",
            type_of_tariff: "Месяц",
            duration_of_action: 6,
            duration_of_action_def:6,
            create_rent: true
         }
        },
        {
          id:"23d56db0-ed07-11ea-812c-9c5c8e747603",
          name:"Аренда шкафчика на 1 месяц (клевер)",
          price:1650,
          date_time_start:null,
          date_time_end:null,
          return_date:null,
          return_time:null,
          activation_type: "",
          rental_type: "Шкафы",
          rental: {
            type_locker_id: "c214ad10-f010-11ea-812c-9c5c8e747603",
            type_locker_name: "шкафы клевер",
            type_of_tariff: "Месяц",
            duration_of_action: 1,
            duration_of_action_def:1,
            create_rent: true
         }
        },
        {
          id:"36aa21da-ef56-11ea-812c-9c5c8e747603",
          name:"Аренда шкафчика на год (VIP) (клевер)",
          price:"0",
          date_time_start:null,
          date_time_end:null,
          return_date:null,
          return_time:null,
          activation_type: "",
          rental_type: "Шкафы",
          rental: {
            type_locker_id: "c214ad10-f010-11ea-812c-9c5c8e747603",
            type_locker_name: "шкафы клевер",
            type_of_tariff: "Месяц",
            duration_of_action: 12,
            duration_of_action_def:12,
            create_rent: true
         }
        }
      ],
      date:new Date(),
      date2:new Date(),
      date3:new Date(),
      start_age:1,
      rulesMonth: [
         v => !!v || 'Required',
         v => v >= 1 || 'Минимум 1'
      ],
      rentalArray:[],
      rentalFormLoading:false,
      endAgeRules:  [
        v => {
          if (v >= 0 && v !== '' && v !== null) return /^\d+$/.test(v) && v >= (this.start_age + 1) && v <= 350 || 'Введите число от 1';
          else return true;
        }
      ],
      showHeaderNew:false,
      noCountServices:{
        'АбонементЧленство': 'АбонементЧленство',
        'МодификаторЧленствПакетов': 'МодификаторЧленствПакетов',
        'ПодарочныйСертификат': 'ПодарочныйСертификат'
      },
      buyerSaleModal:false,
      buyer_sale_type_list:[
        {
          "name":"Безналичные",
          "id":1
        }
      ],
      buyer_sale_type:{
        "name":"Безналичные",
        "id":1
      },
      buyer_sale_main:null,
      returnModal:false,
      specialist_def:[],
      pay_promo:null,
      pay_promo_setted:null,

      dataMatrixDialog:false,
      // Значение, которое вводит сканер
      dataMatrixCode: '',

      // Текущий товар, для которого сканируем код
      currentMarkingIndex: 0,

      // Сколько кодов уже отсканировано для текущего товара
      currentScannedCount: 0,

      // Список отсканированных кодов
      markingCodes: [],

      scanningItem: null,
      scanningLoading: false,
      snackbar: false,
      snackbarText: '',
    }
  },
  methods: {
    clearPromo(){

      if(!this.pay_promo_setted){
        this.pay_promo = null
        return;
      }

      this.pay_promo = null
      this.pay_promo_setted = null

      if(this.type === 'new'){
              for(let i = 0; i < this.nomenclatures.length; i++){
                  this.nomenclatures[i].discount = 0
                  this.nomenclatures[i].total = this.nomenclatures[i].price
              }
            } else {

              for(let i = 0; i < this.saleInfo.sales.buy_list.length; i++){
                this.saleInfo.sales.buy_list[i].discount = 0
                this.saleInfo.sales.buy_list[i].total = this.saleInfo.sales.buy_list[i].price
              }
              
            }
   
    },
    detailBuyer(pay){
        if(!this.saleInfo || !this.saleInfo.sales || !this.saleInfo.sales.id){
              alert('Детализация не возможна!')
              return;
            }

            let clId = ''

                if(this.client.crm){
                    clId = this.client.client_id
                  } else {

                  if(this.client && this.client.client_id){
                    clId = this.client.client_id
                  } else {
                    this.client = JSON.parse(this.client)
                    clId = this.client.client_id
                  }

                }

                let org_inn = (this.sale && this.sale.org && this.sale.org.inn) ? this.sale.org.inn : '1650387117'


              let client_name = (this.client && this.client.name) ? this.client.name : (this.client.last_name + ' ' + this.client.first_name)
              console.log(client_name)

            this.summ_cash_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
            this.summ_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;

            let pays_sum = 0

            if(this.saleInfo.sales && this.saleInfo.sales.pays) {
              pays_sum = this.saleInfo.sales.pays.reduce((res, i) => res + i.sum_in, 0)

              this.summ_cash_part = this.summ_cash_part - pays_sum
              this.summ_part = this.summ_part - pays_sum

            }

            this.$router.push({
              name: 'SaleBuyer',
              params: {
                  client_id: clId,
                  client_name_buyer:client_name,
                  org_inn: org_inn,
                  service_list_buyer: this.saleInfo.sales.buy_list,
                  buy_id:this.saleInfo.sales.id,
                  summ_cash_part_buyer:this.summ_cash_part,
                  summ_part_buyer:pay.sum_in,
                  detail:true,
                  pays:[pay]
                }
          });
    },
    buyerSaleOpen(){

      let nomenclatures = this.type === 'new' ? this.nomenclatures : this.saleInfo.sales.buy_list;
      let resPrice = 0

      let confirmText = "После подтверждения будет создана продажа. Продолжить?"

      if (confirm(confirmText) == true) {

      } else {
        return;
      }


      // if(this.type === 'new'){

      //   let acDate = false

      //   if(nomenclatures) {
      //     for (let item of nomenclatures) {
      //       if(item.activation_type && item.activation_type.split('при пр')[1]){
      //         acDate = true
      //       }
      //     }
      //   }

      //   if(acDate && acDate === true){
      //     for (let item of nomenclatures) {
      //       if(!item.activation_date_new || item.activation_date_new.length < 2) {
      //         alert('Не задана дата активации!');
      //         return;
      //       }
      //     }
      //   }

      // }

      if(!nomenclatures || nomenclatures.length === 0) {
        return;
      }

      let list = [];

      for (let item of nomenclatures) {

        let summik = (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count

          list.push({
            service_id: item.service.id,
            price: item.price,
            count: item.count,
            discount: item.discount,
            discount_summ: (item.price * (item.discount/100)) * item.count,
            sum: (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count,
            name:item.service.name,
            specialist_id: item.specialist_id,
            manager_id: (item.manager_id && item.manager_id !== undefined) ? item.manager_id : (getItem('user_id_1c') ? getItem('user_id_1c') : null),
            vat:{
              id:item.vat ? item.vat.id : null,
              sum:item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0,
            },
            vat_id: item.vat ? item.vat.id : null,
            vat_summ: item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0,
            vat_count: item.vat ? item.vat.count : null,
            activation_date:item.activation_date_new ? item.activation_date_new : item.activation_date
          })
      }

      console.log(this.client)

      let clId = ''

      if(this.client.crm){
           clId = this.client.client_id
        } else {

        if(this.client && this.client.client_id){
           clId = this.client.client_id
        } else {
          this.client = JSON.parse(this.client)
           clId = this.client.client_id
        }

      }

      let org_inn = (this.sale && this.sale.org && this.sale.org.inn) ? this.sale.org.inn : (this.saleOrg ? this.saleOrg.inn : 0)
      let org_obj = (this.sale && this.sale.org && this.sale.org.inn) ? this.sale : (this.saleOrg ? this.saleOrg : {})

      let client_name = (this.client && this.client.name) ? this.client.name : (this.client.last_name + ' ' + this.client.first_name)
      console.log(client_name)

      if(this.type === 'new') {

        this.$store.dispatch(salesActionTypes.createSalePart, {
            org_inn: org_inn, //t
            client_id: clId,
            fio: this.userFIO,
            service_list: list,
            bonus_obj: this.main_bonus_part,
            deal_id: this.deal ? this.deal : null,
            promo:this.pay_promo ? this.pay_promo : null
        })
        .then((response) => {
          if (response.success) {
            //сохраняем айди продажи локально
            this.buy_id_payment = response.sale.buy_id;
            if(response.sale.service_list){
              this.buy_payment_list = response.sale.service_list
            }
            if(response.sale.sale_sum){
              this.summForPaymentPart = response.sale.sale_sum
            }
   

            this.summ_cash_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
            this.summ_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;

            setItem('buyer_saler',JSON.stringify(org_obj))

            this.$router.push({
              name: 'SaleBuyer',
              params: {
                  client_id: clId,
                  client_name_buyer:client_name,
                  org_inn: org_inn,
                  service_list_buyer: this.buy_payment_list,
                  buy_id:this.buy_id_payment,
                  summ_cash_part_buyer:this.summ_cash_part,
                  summ_part_buyer:this.summ_part,
                  new_org: (this.sale && this.sale.org && this.sale.org) ? this.sale.org : (this.saleOrg ? this.saleOrg : null)
                  }
              });
            
          } else {
            alert('Ошибка создания продажи!')
          }
        })

      } else {

            if(!this.saleInfo || !this.saleInfo.sales || !this.saleInfo.sales.id){
              alert('Оплата не возможна!')
              return;
            }

            this.summ_cash_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
            this.summ_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;

            let pays_sum = 0

            if(this.saleInfo.sales && this.saleInfo.sales.pays) {

              pays_sum = this.saleInfo.sales.pays.reduce((res, i) => res + i.sum_in, 0)

              this.summ_cash_part = this.summ_cash_part - pays_sum
              this.summ_part = this.summ_part - pays_sum

            }

            this.$router.push({
              name: 'SaleBuyer',
              params: {
                  client_id: clId,
                  client_name_buyer:client_name,
                  org_inn: org_inn,
                  service_list_buyer: this.saleInfo.sales.buy_list,
                  buy_id:this.saleInfo.sales.id,
                  summ_cash_part_buyer:this.summ_cash_part,
                  summ_part_buyer:this.summ_part,
                  detail:false,
                  pays:this.saleInfo.sales.pays
                  }
          });

      }

      
    },
    checkClosePay(){

      let buyId = (this.saleInfo && this.saleInfo.sales && this.saleInfo.sales.id) ? this.saleInfo.sales.id : (this.buy_id_payment ? this.buy_id_payment : null)

      if(buyId && this.type === 'new') {
        let confirmText = "Пометить Продажу на удаление?"

          if (confirm(confirmText) == true) {
              this.$store.dispatch(salesActionTypes.buyDelete, {
              buy_id: buyId,
              status: true
          })
          .then((response) => {
              console.log(response)
              this.$store.dispatch(salesActionTypes.getSaleInfo, {buy_id:buyId});
              this.dialogPayment2 = false
          });

          } else {
            this.dialogPayment2 = false
          }

      } else {
        console.log('nettuuu')
        this.dialogPayment2 = false
      }

    },
    handleScroll(event) {
      // console.log('scrool')
      // // Any code to be executed when the window is scrolled
      // console.log(window.scrollY)
      // console.log('calling handleScroll');

      if(window.scrollY > 50) {
        this.showHeaderNew = true
      } else {
        this.showHeaderNew = false
      }
    },
    downEndAge() {
      if (this.rentaItem.rental.duration_of_action_def === '' || this.rentaItem.rental.duration_of_action_def === null) {
        
        if(this.rentaItem.rental.duration_of_action === 6){
          this.rentaItem.rental.duration_of_action_def = 6;
        }
        if(this.rentaItem.rental.duration_of_action === 1){
          this.rentaItem.rental.duration_of_action_def = 1;
        }
        if(this.rentaItem.rental.duration_of_action === 12){
          this.rentaItem.rental.duration_of_action_def = 12;
        }
      } else {
        if (this.rentaItem.rental.duration_of_action_def !== 0) {
          if(this.rentaItem.rental.duration_of_action === 6){
            this.rentaItem.rental.duration_of_action_def = this.rentaItem.rental.duration_of_action_def - 6
            if(this.rentaItem.rental.duration_of_action_def < 6){
              this.rentaItem.rental.duration_of_action_def = 6
            }
            
          }
          if(this.rentaItem.rental.duration_of_action === 1){
            this.rentaItem.rental.duration_of_action_def = this.rentaItem.rental.duration_of_action_def - 1
            if(this.rentaItem.rental.duration_of_action_def < 1){
              this.rentaItem.rental.duration_of_action_def = 1
            }
          }
          if(this.rentaItem.rental.duration_of_action === 12){
            this.rentaItem.rental.duration_of_action_def = this.rentaItem.rental.duration_of_action_def - 12
            if(this.rentaItem.rental.duration_of_action_def < 12){
              this.rentaItem.rental.duration_of_action_def = 12
            }
          }
        }
      }

      this.$set(this.rentaItem.rental, 'summ', (this.rentaItem.rental.duration_of_action_def/this.rentaItem.rental.duration_of_action)*this.rentaItem.price)

      let normMon = this.rentaItem.rental.duration_of_action_def

      let date = this.rentaItem.date_time_start

      this.rentaItem.return_date = new Date(new Date(date).setMonth(new Date(date).getMonth() + normMon));

      this.rentalFormLoading = true

      const FLASH_TIMEOUT = 150;

      setTimeout(() => {
        this.rentalFormLoading = false;
      }, FLASH_TIMEOUT);
    },
    upEndAge() {
      if (this.rentaItem.rental.duration_of_action_def === '' || this.rentaItem.rental.duration_of_action_def === null) {
        if(this.rentaItem.rental.duration_of_action === 12){
          this.rentaItem.rental.duration_of_action_def = 12;
        }
      } else {
        if (this.rentaItem.rental.duration_of_action_def !== 0) {
          if(this.rentaItem.rental.duration_of_action === 6){
            this.rentaItem.rental.duration_of_action_def = this.rentaItem.rental.duration_of_action_def + 6
            if(this.rentaItem.rental.duration_of_action_def < 6){
              this.rentaItem.rental.duration_of_action_def = 6
            }
            
          }
          if(this.rentaItem.rental.duration_of_action === 1){
            this.rentaItem.rental.duration_of_action_def = this.rentaItem.rental.duration_of_action_def + 1
            if(this.rentaItem.rental.duration_of_action_def < 1){
              this.rentaItem.rental.duration_of_action_def = 1
            }
          }
          if(this.rentaItem.rental.duration_of_action === 12){
            this.rentaItem.rental.duration_of_action_def = this.rentaItem.rental.duration_of_action_def + 12
            if(this.rentaItem.rental.duration_of_action_def < 12){
              this.rentaItem.rental.duration_of_action_def = 12
            }
          }
        }
      }

      this.$set(this.rentaItem.rental, 'summ', (this.rentaItem.rental.duration_of_action_def/this.rentaItem.rental.duration_of_action)*this.rentaItem.price)

      let normMon = this.rentaItem.rental.duration_of_action_def

      let date = this.rentaItem.date_time_start

      this.rentaItem.return_date = new Date(new Date(date).setMonth(new Date(date).getMonth() + normMon));

      this.rentalFormLoading = true

      const FLASH_TIMEOUT = 150;

      setTimeout(() => {
        this.rentalFormLoading = false;
      }, FLASH_TIMEOUT);

    },

    dateChange(){

      console.log('date-changed')

      let normMon = this.rentaItem.rental.duration_of_action_def

      let date = this.rentaItem.date_time_start

      this.rentaItem.return_date = new Date(new Date(date).setMonth(new Date(date).getMonth() + normMon));

      this.rentalFormLoading = true

      const FLASH_TIMEOUT = 150;

      setTimeout(() => {
        this.rentalFormLoading = false;
      }, FLASH_TIMEOUT);

    },
    changeMonths(){

      this.$set(this.rentaItem.rental, 'summ', (this.rentaItem.rental.duration_of_action_def/this.rentaItem.rental.duration_of_action)*this.rentaItem.price)

      this.rentalFormLoading = true

      const FLASH_TIMEOUT = 150;

      setTimeout(() => {
        this.rentalFormLoading = false;
      }, FLASH_TIMEOUT);

      //this.$refs.formRent.reset();

      console.log(this.rentaItem)
      // let normMon = +this.rentaItem.rental.duration_of_action
      // this.rentaItem.return_date = null
      // if((+this.rentaItem.rental.duration_of_action_def < 1) || (!Number.isInteger(+this.rentaItem.rental.duration_of_action_def))){
      //   this.rentaItem.rental.duration_of_action_def = normMon
      //   this.rentaItem.return_date = new Date(new Date(date).setMonth(date.getMonth() + normMon));
      //   console.log('Не верно')
      // } else {
      //   let date = new Date()
      //   this.rentaItem.return_date = new Date(new Date(date).setMonth(date.getMonth() + this.rentaItem.rental.duration_of_action_def));
      // }
    },
    saveRental(){

      let rental = {}
      rental.org_inn = (this.sale && this.sale.org && this.sale.org.inn) ? this.sale.org.inn : (this.saleOrg ? this.saleOrg.inn : 0)
      rental.client_id = this.client.client_id
      rental.rental_list = this.rentalArray

      console.log(rental)

      this.$store.dispatch(salesActionTypes.createRental,{rental:rental})
        .then((response) => {
          if(response && response.rental) {
            this.$router.push({
              name: 'Desktop',
              params: {
                  client_id: this.client.client_id
                  }
              });
          }
        });
    },
    makeRental(){
      console.log(this.rentaItem)

      //this.rentaItem.total = this.rentaItem.price
      this.rentaItem.total = this.rentaItem.rental.summ

      this.rentalArray.push(this.rentaItem)
      this.rentaItemDialog = false

    },
    buyDeletion(status){
      console.log(!status)

      let confirmText = "Пометить 'Продажа " + this.saleInfo.sales.summ + "р от " + this.saleInfo.sales.date + "' на удаление?"
      if(!status === false) {
        confirmText = "Снять с 'Продажа " + this.saleInfo.sales.summ + "р от " + this.saleInfo.sales.date + "' пометку на удаление?"
      }

        if (confirm(confirmText) == true) {

          this.$store.dispatch(salesActionTypes.buyDelete, {
              buy_id: this.saleInfo.sales.id ? this.saleInfo.sales.id : (this.buy_id_payment ? this.buy_id_payment : null),
              status: !status
          })
          .then((response) => {
              console.log(response)
              this.$store.dispatch(salesActionTypes.getSaleInfo, {buy_id:this.saleInfo.sales.id});
          });

        }


    },
    buyDeletion2(buyid){

      let confirmText = "Пометить Продажу на удаление?"

      if (confirm(confirmText) == true) {

        this.$store.dispatch(salesActionTypes.buyDelete, {
            buy_id: buyid,
            status: true
        })
        .then((response) => {
            console.log(response)
            this.$store.dispatch(salesActionTypes.getSaleInfo, {buy_id:buyid});
        });

        }
        
    },
    checkSumm(){
      if(+this.cash_in_part >= +this.summ_cash_part){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
        this.canAddSumm = false
        return;
      } else {
        this.canAddSumm = true
      }
    },
    toCashPay(){
      if(+this.cash_in_part >= +this.summ_cash_part){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
        this.canAddSumm = false
        return;
      }
      if(this.ifCashPay){
        this.ifCashPay = false
        
        
        if(this.cash_in_part_setted){
          this.cash_in_part = this.cash_in_part - (+this.cash_in_part_pre)
        }
        this.cash_in_part_setted = false
        this.cash_in_part_pre = 0
      } else {
        this.cash_in_part_pre = this.summ_cash_part - this.cash_in_part
        this.ifCashPay = true
      }
    },
    toCardPay(){
      if(+this.cash_in_part >= +this.summ_cash_part){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
        this.canAddSumm = false
        return;
      }
      if(this.ifCardPay){
        this.ifCardPay = false
        
        
        if(this.card_part_setted){
          this.cash_in_part = this.cash_in_part - (+this.summ_card_part_pre)
        }
        this.card_part_setted = false
        this.summ_card_part_pre = 0
      } else {
        this.summ_card_part_pre = this.summ_cash_part - this.cash_in_part
        this.ifCardPay = true
      }
    },
    setCashboxTerminal(){
      if(!this.listCashbox || !this.listCashbox[0]){
        alert('Не подключена или неполадки с кассой! Автоматически подставлена касса ИП Сорокин на Reception3_kl!')
      } 
      console.log(this.listCashbox)
      console.log(this.term_i)
      //if(this.listCashbox && this.listCashbox[this.term_i] && this.listCashbox[this.term_i].serial){
        console.log('по кассам')

        this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
          till_id: this.sale.org.serial
        }).then((resp) => {
        console.log(resp)
        if(resp && resp.cashbox && resp.cashbox.terminals && resp.cashbox.terminals.length > 0) {
            this.cashboxTerminal = resp.cashbox.terminals[0].id
            this.ChangeSaleOrg(true)
          } else {
            this.cashboxTerminal = null
            alert('Нет доступного терминала по выбранной кассе!')
            this.ChangeSaleOrg(true)
        }
        //  } else {
        //    alert('Неполадки с кассой, либо нет терминалов по выбранной кассе! Автоматически подставился стандартный теримнал ООО Клевер!')
        //  }
        })
     // }
    },
    handleSearch(input) {
      // console.log(+input)
      // if(input && +input && +input != NaN){
      //   input = '('+(+input)
      // }
      if (input && input.length >= 2) {
        this.$refs.myTree.updateAll(true)
      } else {
        this.$refs.myTree.updateAll(false)
      }
    },
    fetchFeed(buy_id, type){
      if (type === 'exist' || type === 'edit' || type === 'info') {

        this.$store.dispatch(salesActionTypes.getSaleInfo, { buy_id }).then((response) => {
          if (response && response.sales) {

            if(response.sales.org && response.sales.org.inn){

                let orgInn = response.sales.org.inn

                if(JSON.parse(getItem('select_org-sale'))){
                  let org = JSON.parse(getItem('select_org-sale'));
                  let inn = org.inn

                  if (orgInn !== inn) {

                    console.log('КАССЫ НЕ СОВПАДАЮТ')

                    if(this.listCashbox) {

                          console.log('ищем подходящую кассу для оплаты')

                          let cresditCashboxes = this.listCashbox.filter(cashboxItem => {
                            return this.credits.some(creditItem => cashboxItem.inn === orgInn);
                          });

                          if(cresditCashboxes) {

                            console.log('нашли кассу и подставляем')

                            this.sale.org = cresditCashboxes;

                          } else {

                            console.log('нет подходящих касс')

                          }

                    }


                  } else {

                    console.log('КАССЫ НЕ СОВПАДАЮТ')

                  }

                }

            }
            
          }
        });

      }
      if (type === 'new' || type === 'edit') {
        //let org_inn = '1650387117'
        let org_inn = (this.sale && this.sale.org && this.sale.org.inn) ? this.sale.org.inn : (this.saleOrg ? this.saleOrg.inn : 0)
        this.$store.dispatch(salesActionTypes.getSalesAllList, {org_inn});
      }
      this.$store.dispatch(salesActionTypes.getSalesOrganizations, {});

    },
    addCountNomenclature(item){

      if(item.marking_code) {
        return
      }
      
      item.count++;
      item.total = item.price * item.count;
    },
    subtractCountNomenclature(item){

      if(item.marking_code) {
        return
      }

      if (item.count !== 1) {
        item.count--;
        item.total = item.price * item.count;
      }
    },
    changeRental(){
      console.log(this.rentaItem)
      this.rentaItem.date_time_start = new Date()
      this.rentaItem.date_time_end = (new Date().getHours()+1) + ':00'

      let date = new Date()

      this.rentaItem.return_date = new Date(new Date(date).setMonth(date.getMonth() + this.rentaItem.rental.duration_of_action));
      this.rentaItem.return_time = (new Date().getHours()+1) + ':00'

      this.$store.dispatch(salesActionTypes.getRentalsTypes,{type_locker_id: this.rentaItem.rental.type_locker_id})
        .then((response) => {
          if(response && response.rental) {
            //this.rentaItemDialog = true
          }
        });
    },

    addToNomenclature(item) {
    if (item.marking_is_used !== true) {
      this.addItemToNomenclature(item);
      return;
    }

    this.scanningItem = item;
    this.dataMatrixCode = "";
    this.dataMatrixDialog = true;

    this.$nextTick(() => {
      this.focusDataMatrixInput();
    });
  },

  showError(text) {
      this.snackbarText = text;
      this.snackbar = true;
    },

  focusDataMatrixInput() {
    const input = this.$refs.dataMatrixInput;

    if (input) {
      input.focus();
    }
  },

  async checkDataMatrix() {
  const code = String(this.dataMatrixCode || "").trim();

  if (!code || !this.scanningItem) {
    return;
  }

  this.scanningLoading = true;

  try {
    const response = await this.$store.dispatch(
      nomenclatureActionTypes.checkDataMark,
      {
        marking_code: code
      }
    );

    // Проверяем ответ API
    if (!response) {
      this.showError("Не доступен сервер");
      return;
    }

     // Проверяем ответ API
     if (!response.success) {

      let erText = response.error ? response.error : 'Ошибка проверки маркировочного кода'

      this.showError(erText);
      return;
    }

    // Код успешно проверен
    this.$set(
      this.scanningItem,
      "marking_code",
      code
    );

    console.log("Проверенный товар:", this.scanningItem);

    // Добавляем товар
    this.addItemToNomenclature(this.scanningItem);

    // Закрываем модалку
    this.dataMatrixDialog = false;

    // Очищаем состояние
    this.dataMatrixCode = ""; 
    this.scanningItem = null;

  } catch (error) {
    console.error("Ошибка проверки маркировки:", error);

    this.showError("Ошибка при проверке кода маркировки");

  } finally {
    this.scanningLoading = false;
  }
},

    
addItemToNomenclature(item){

      console.log(item)

      console.log('--b--')

      if(item.rental){
        this.rentaItem = item
        this.rentaItem.id = item.id
        this.rentaItem.price = item.price
        this.rentaItem.name = item.name
        this.rentaItem.date_time_start = new Date()
        this.rentaItem.date_time_end = (new Date().getHours()+1) + ':00'

        this.rentaItem.rental.duration_of_action_def = this.rentaItem.rental.duration_of_action

        let date = new Date()

        this.rentaItem.return_date = new Date(new Date(date).setMonth(date.getMonth() + this.rentaItem.rental.duration_of_action));
        this.rentaItem.return_time = (new Date().getHours()+1) + ':00'

        this.rentaItem.rental = item.rental

        this.rentaItem.rental.summ = (this.rentaItem.rental.duration_of_action_def/this.rentaItem.rental.duration_of_action)*this.rentaItem.price

        this.rentaItem.marking_is_used = item.marking_is_used ? true : false

        this.$store.dispatch(salesActionTypes.getRentalsTypes,{type_locker_id: this.rentaItem.rental.type_locker_id})
        .then((response) => {
          if(response && response.rental) {
            this.rentaItemDialog = true
            this.rentaItem.rentalType = this.rentalsTypes.rental[0]
            this.chosedRentalType = this.rentalsTypes.rental[0]
          }
        });

        
      } else {

        console.log('--b-1-')

        let list = [];

        list = this.type === 'edit' ? this.saleInfo.sales.buy_list : this.nomenclatures;

        if ((list.findIndex((n) => n.service.id === item.id) !== -1) && !item.marking_code) {

          let nomenclature = list.find(n => n.service.id === item.id);

          if(!this.noCountServices[nomenclature.type]){
            nomenclature.count++;
            nomenclature.total = nomenclature.total * nomenclature.count;
          } else {
            item.count = 1;
            let price = (item.price === -1 ? 0 : item.price);
            list.push({
              service: {
                id: item.id,
                name: item.name
              },
              price,
              count: item.count,
              discount: item.discount ? item.discount : 0,
              total: price * item.count,
              specialist_id:null,
              manager_id: (item.manager_id && item.manager_id !== undefined) ? item.manager_id : (getItem('user_id_1c') ? getItem('user_id_1c') : null),
              activation_type: item.activation_type ? item.activation_type : null,
              type: item.type ? item.type : null,
              vat_id: item.vat ? item.vat.id : null,
              vat_count: item.vat ? item.vat.count : null,
              vat: item.vat ? item.vat : null,
              marking_is_used: item.marking_is_used ? true : false,
              marking_code: item.marking_code ?? null
            });
          }

        } else {

          console.log('--b-2-')

          item.count = 1;
          let price = (item.price === -1 ? 0 : item.price);
          list.push({
            service: {
              id: item.id,
              name: item.name
            },
            price,
            count: item.count,
            discount: item.discount ? item.discount : 0,
            total: price * item.count,
            specialist_id:null,
            manager_id: (item.manager_id && item.manager_id !== undefined) ? item.manager_id : (getItem('user_id_1c') ? getItem('user_id_1c') : null),
            activation_type: item.activation_type ? item.activation_type : null,
            type: item.type ? item.type : null,
            vat_id: item.vat ? item.vat.id : null,
            vat_count: item.vat ? item.vat.count : null,
            vat: item.vat ? item.vat : null,
            marking_is_used: item.marking_is_used ? true : false,
              marking_code: item.marking_code ?? null
          });
        }

        console.log(list)

        this.$store.dispatch(lessonActionTypes.getSpecialistList,{service_id:item.id});

      }

    },
    deleteFromNomenclature(item,rental){
      let list = [];
      list = rental ? this.rentalArray : this.nomenclatures

      if(rental){
        if (list.findIndex(n => n.id === item.id) !== -1) {
          list.splice(list.findIndex(n => n.id === item.id),1);
        }
      } else {
        if (list.findIndex(n => n.service.id === item.service.id) !== -1) {
          list.splice(list.findIndex(n => n.service.id === item.service.id),1);
        }
      }
    },
    saveSale() {



      if(this.buy_id_payment){
        alert('Продажа сохранена!');
        this.$router.push({
        name: 'Desktop',
        params: {
             client_id: this.client.client_id
            }
        });

        return;
      }

      

      let list = [];
      let nomenclatures = [];

      nomenclatures = (this.type === 'edit' || this.type === 'exist') ? this.saleInfo.sales.buy_list : this.nomenclatures


      let acDate = false

      if(nomenclatures) {
        for (let item of nomenclatures) {
          if(item.activation_type && item.activation_type.split('при пр')[1]){
            acDate = true
          }
        }
      }

      if(acDate && acDate === true){
        for (let item of nomenclatures) {
          if(!item.activation_date_new || item.activation_date_new.length < 2) {
            alert('Не задана дата активации!');
            return;
          }
        }
      }

      for (let item of nomenclatures) {

        let summik = (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count

        list.push({
          service_id: item.service.id,
          name:item.service.name,
          price: item.price,
          count: item.count,
          discount: item.discount,
          discount_summ: (item.price * (item.discount/100)) * item.count,
          sum: (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count,
          specialist_id: (item.specialist_id && item.specialist_id !== undefined) ? item.specialist_id : ((item.specialist && item.specialist.id) ? item.specialist.id : null),
          manager_id: (item.manager_id && item.manager_id !== undefined) ? item.manager_id : ((item.manager && item.manager.id) ? item.manager.id : (getItem('user_id_1c') ? getItem('user_id_1c') : null)),
          activation_date:item.activation_date_new ? item.activation_date_new : item.activation_date,
          vat:{
              id:item.vat ? item.vat.id : null,
              sum:item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0,
            },
            vat_id: item.vat ? item.vat.id : null,
            vat_summ: item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0,
            vat_count: item.vat ? item.vat.count : null,
            sum_old: item.sum_old ? item.sum_old : null
        })
      }
      if (this.type === 'new') {

        if(this.sale.org && this.sale.org && this.sale.org.inn){

        } else {
          if(!this.saleOrg){

            if (confirm("Предупреждение. Не привязан ИНН (касса) и не выбрана организация! Автоматически будет выбрана организация ООО КлеверСпорт") == true) {
              for(var u in this.listOrganizations.sales) {
                if(this.listOrganizations.sales[u].inn === "1650387117"){
                  this.saleOrg = this.listOrganizations.sales[u]
                }
              }
              if(!this.saleOrg){
                this.saleOrg = this.listOrganizations.sales[0]
              }
            } else {
              for(var u in this.listOrganizations.sales) {
                if(this.listOrganizations.sales[u].inn === "1650387117"){
                  this.saleOrg = this.listOrganizations.sales[u]
                }
              }
              if(!this.saleOrg){
                this.saleOrg = this.listOrganizations.sales[0]
              }
              return;
            }


          }
        }

        // if(!this.sale_org_changed){
        //   alert('Выберите организацию!')
        //   return;
        // }

        this.$store.dispatch(salesActionTypes.createSale, {
          org_inn: (this.sale.org && this.sale.org && this.sale.org.inn) ? this.sale.org.inn : (this.saleOrg ? this.saleOrg.inn : 0),
          client_id: this.client.client_id,
          fio: this.userFIO,
          service_list: list,
          manager_id:getItem('user_id_1c'),
          deal_id: this.deal ? this.deal : null,
          promo:this.pay_promo ? this.pay_promo : null
        })
            .then((response) => {
              this.type = 'exist';
              this.$router.push({
                                      name: 'Desktop',
                                      params: {
                                        client_id: this.client.client_id
                                      }
                                    });
              this.fetchFeed(response.sale.buy_id, this.type);
      
            })
      }
      
      if (this.type === 'edit' || this.type === 'exist') {
          console.log(this.saleOrg)
          console.log(this.sale)
        if(this.saleInfo.sales && this.saleInfo.sales.org && this.saleInfo.sales.org.id){

        } else {
          if(!this.saleOrg){
            alert('Предупреждение. Не привязан ИНН (касса) и не выбрана организация!')
            return;
          }
        }
        this.$store.dispatch(salesActionTypes.editSale, {
          org_inn: (this.sale.org && this.sale.org && this.sale.org.inn) ? this.sale.org.inn : (this.saleInfo.sales.org.inn ? this.saleInfo.sales.org.inn : 0),
          buy_id: this.saleInfo.sales.id,
          fio: this.userFIO,
          service_list: list,
          promo:this.pay_promo ? this.pay_promo : null
        })
            .then(() => {
              this.type = 'exist'
              //this.fetchFeed(this.saleInfo.sales.id, this.type);
              this.$router.push({
                                      name: 'Desktop',
                                      params: {
                                        client_id: this.client.client_id
                                      }
                                    });
            })
      }

    },
    printSaleBuy(){
      console.log(this.nomenclatures)
      if(!this.nomenclatures){
        alert('Печать договора не возможна!');
        return;
      }
      if (confirm("Документ еще не проведен. Выполнение действия возможно только после проведения документа. Документ будет проведен, продолжить?") == true) {
          console.log('continue')
        } else {
          return;
      }


      let list = [];
      let nomenclatures = [];
      nomenclatures = this.type === 'edit' ? this.saleInfo.sales.buy_list : this.nomenclatures
      for (let item of nomenclatures) {

        let summik = (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count

        console.log(item)
        list.push({
          service_id: item.service.id,
          name:item.service.name,
          price: item.price,
          count: item.count,
          discount: item.discount,
          discount_summ: (item.price * (item.discount/100)) * item.count,
          sum: (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count,
          specialist_id: item.specialist_id,
          manager_id: (item.manager_id && item.manager_id !== undefined) ? item.manager_id : (getItem('user_id_1c') ? getItem('user_id_1c') : null),
          activation_date:item.activation_date_new,
          vat:{
              id:item.vat ? item.vat.id : null,
              sum:item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0,
            },
            vat_id: item.vat ? item.vat.id : null,
            vat_summ: item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0,
            vat_count: item.vat ? item.vat.count : null
        })
      }

        if(this.sale.org && this.sale.org && this.sale.org.inn){

        } else {
          if(!this.saleOrg){

            if (confirm("Предупреждение. Не привязан ИНН (касса) и не выбрана организация! Автоматически будет выбрана организация ООО КлеверСпорт") == true) {
              for(var u in this.listOrganizations.sales) {
                if(this.listOrganizations.sales[u].inn === "1650387117"){
                  this.saleOrg = this.listOrganizations.sales[u]
                }
              }
              if(!this.saleOrg){
                this.saleOrg = this.listOrganizations.sales[0]
              }
            } else {
              for(var u in this.listOrganizations.sales) {
                if(this.listOrganizations.sales[u].inn === "1650387117"){
                  this.saleOrg = this.listOrganizations.sales[u]
                }
              }
              if(!this.saleOrg){
                this.saleOrg = this.listOrganizations.sales[0]
              }
              return;
            }


          }
        }

        this.$store.dispatch(salesActionTypes.createSale, {
          org_inn: (this.sale.org && this.sale.org && this.sale.org.inn) ? this.sale.org.inn : (this.saleOrg ? this.saleOrg.inn : 0),
          client_id: this.client.client_id,
          fio: this.userFIO,
          service_list: list,
          manager_id:getItem('user_id_1c'),
          deal_id: this.deal ? this.deal : null,
          promo:this.pay_promo ? this.pay_promo : null
        })
            .then((response) => {
              
              if(response && response.sale && response.sale.buy_id){
                this.type = 'exist';
                  this.$store.dispatch(salesActionTypes.printSale,{
                    buy_id: response.sale.buy_id
                  }).then((response2) => {
                    if (response2 && response2.success) {
                      //печатаем
                      console.log(response2)
                      let link = document.createElement('a');
                      link.href = response2.link;
                      link.target = 'a_blank';
                      let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                      link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();

                        this.$router.push({
                          name: 'Desktop',
                          params: {
                              client_id: this.client.client_id
                              }
                          });
                    } else {
                      alert('Ошибка генерации документа')
                    }
                
                  })
              } else {
                alert('Ошибка создания продажи!')
              }
      
            })

    },
    printSale(){
      console.log(this.saleInfo)
      if(!this.saleInfo.sales || !this.saleInfo.sales.buy_list){
        alert('Печать договора не возможна!');
        return;
      }
      this.$store.dispatch(salesActionTypes.printSale,{
                    buy_id: this.saleInfo.sales.id
                  }).then((response2) => {
                    if (response2 && response2.success) {
                      //печатаем
                      console.log(response2)
                      let link = document.createElement('a');
                      link.href = response2.link;
                      link.target = 'a_blank';
                      let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                      link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      this.$router.push({
                          name: 'Desktop',
                          params: {
                              client_id: this.client.client_id
                              }
                          });s
                    } else {
                      alert('Ошибка генерации документа')
                    }
                
                  })

    },
    changeToEdit() {
      this.type = 'edit'
      this.fetchFeed(this.saleInfo.sales.id, this.type);
    },
    setPromo(){

      let nomenclatures = this.type === 'new' ? this.nomenclatures : this.saleInfo.sales.buy_list;
      let resPrice = 0


      if(this.type === 'new'){

        let acDate = false

        if(nomenclatures) {
          for (let item of nomenclatures) {
            if(item.activation_type && item.activation_type.split('при пр')[1]){
              acDate = true
            }
          }
        }

        if(acDate && acDate === true){
          for (let item of nomenclatures) {
            if(!item.activation_date_new || item.activation_date_new.length < 2) {
              alert('Не задана дата активации!');
              return;
            }
          }
        }

      }

      let list = [];
      for (let item of nomenclatures) {

        let summik = (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count

          list.push({
            service_id: item.service.id,
            price: item.price,
            count: item.count,
            discount: item.discount,
            discount_summ: (item.price * (item.discount/100)) * item.count,
            sum: (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count,
            name:item.service.name,
            specialist_id: item.specialist_id,
            manager_id: (item.manager_id && item.manager_id !== undefined) ? item.manager_id : (getItem('user_id_1c') ? getItem('user_id_1c') : null),
            vat:{
              id:item.vat ? item.vat.id : null,
              sum:item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0,
            },
            vat_id: item.vat ? item.vat.id : null,
            vat_summ: item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0,
            vat_count: item.vat ? item.vat.count : null
          })
      }


      //проверяем ПРОМО
      if(!this.pay_promo_setted) {

        if(this.pay_promo && this.pay_promo.length > 0) {

          this.getPromoSumm(list)

          return;

        } else {
          this.pay_promo = null
        }

      }

    },
    getPromoSumm(list){

      this.$store.dispatch(salesActionTypes.salePromo, {
            //org_inn: this.sale.org.inn,
            client_id: this.client.client_id,
            service_list: list,
            pay_promo: this.pay_promo
        })
        .then((response) => {
          if(response && response.success && response.sales && Object.keys(response.sales).length > 0){

            let nomenclatures = this.type === 'new' ? this.nomenclatures : this.saleInfo.sales.buy_list;

            console.log(nomenclatures)

            if(this.type === 'new'){
              for(let i = 0; i < this.nomenclatures.length; i++){
                if(this.nomenclatures[i] && this.nomenclatures[i].service && this.nomenclatures[i].service.id && response.sales[this.nomenclatures[i].service.id]){
                  
                  console.log('estj promo')
                  this.pay_promo_setted = true
                  // this.nomenclatures[i].discount = response.sales[this.nomenclatures[i].service.id].discount
                  // this.nomenclatures[i].total = response.sales[this.nomenclatures[i].service.id].sum
                  this.nomenclatures[i].discount = ((response.sales[this.nomenclatures[i].service.id].discount/response.sales[this.nomenclatures[i].service.id].price)*100)
                  this.nomenclatures[i].total = response.sales[this.nomenclatures[i].service.id].sum
                  this.nomenclatures[i].sum_old = this.nomenclatures[i].price
                  
                }
              }
            } else {

              let afterPromoSumm = 0

              for(let i = 0; i < this.saleInfo.sales.buy_list.length; i++){

                if(this.saleInfo.sales.buy_list && this.saleInfo.sales.buy_list[i] && this.saleInfo.sales.buy_list[i].service && this.saleInfo.sales.buy_list[i].service.id && response.sales[this.saleInfo.sales.buy_list[i].service.id]){

                  console.log('estj promo 3')

                  this.saleInfo.sales.buy_list[i].discount = ((response.sales[this.saleInfo.sales.buy_list[i].service.id].discount/response.sales[this.saleInfo.sales.buy_list[i].service.id].price)*100)
                  this.saleInfo.sales.buy_list[i].total = response.sales[this.saleInfo.sales.buy_list[i].service.id].sum

                  this.saleInfo.sales.buy_list[i].sum_old = this.saleInfo.sales.buy_list[i].price

                  afterPromoSumm = afterPromoSumm + this.saleInfo.sales.buy_list[i].total

                  console.log(afterPromoSumm)

                }
              }

              this.saleInfo.sales.summ = (afterPromoSumm && afterPromoSumm > 0) ? afterPromoSumm : this.saleInfo.sales.summ


            }
         
            

          } else {
            alert('Промокод не используется.')
            this.pay_promo = null
            this.pay_promo_setted = null
          }
        });

        
    },
    modalPayment() {

      console.log(this.nomenclatures)

      // console.log(this.buy_id)
      // console.log(this.type)
      // console.log(this.saleInfo.sales.id)

      

      if(this.sale.org && this.sale.org && this.sale.org.inn && this.listCashbox && (this.listCashbox.length > 0)){
        console.log(this.listCashbox)
      } else {
        if(!this.saleOrg || !this.listCashbox || (this.listCashbox.length === 0)){
          alert('Предупреждение. Не привязан ИНН (касса) и не выбрана организация!')
          //return;
        }
      }
      


    // this.dialogPayment = true;
     this.main_bill_part_pre = 0
     console.log('aak2')
     this.main_bill_part_pre2 = 0
     console.log('aak')
      this.summ_cash_part_pre = 0
      this.summ_card_part_pre = 0
      this.summ_bill_part_pre = 0
      this.cash_in_part_pre = 0
      this.cash_in_part_setted = false
      this.card_part_setted = false
      this.bill_part_setted = false
      this.bonus_part_setted = false

      this.ifCardPay = false
      this.ifCashPay = false

      this.cash_in_part = 0

      let nomenclatures = this.type === 'new' ? this.nomenclatures : this.saleInfo.sales.buy_list;
      let resPrice = 0


      if(this.type === 'new'){

        let acDate = false

        if(nomenclatures) {
          for (let item of nomenclatures) {
            if(item.activation_type && item.activation_type.split('при пр')[1]){
              acDate = true
            }
          }
        }

        if(acDate && acDate === true){
          for (let item of nomenclatures) {
            if(!item.activation_date_new || item.activation_date_new.length < 2) {
              alert('Не задана дата активации!');
              return;
            }
          }
        }

      }

      let list = [];
      for (let item of nomenclatures) {

        let summik = (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count

          list.push({
            service_id: item.service.id,
            price: item.price,
            count: item.count,
            discount: item.discount,
            discount_summ: (item.price * (item.discount/100)) * item.count,
            sum: (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count,
            name:item.service.name,
            specialist_id: item.specialist_id,
            manager_id: (item.manager_id && item.manager_id !== undefined) ? item.manager_id : (getItem('user_id_1c') ? getItem('user_id_1c') : null),
            vat:{
              id:item.vat ? item.vat.id : null,
              sum:item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0,
            },
            vat_id: item.vat ? item.vat.id : null,
            vat_summ: item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0,
            vat_count: item.vat ? item.vat.count : null,
            marking_code: item.marking_code ? item.marking_code : null
          })
      }


      //проверяем ПРОМО
      // if(!this.pay_promo_setted) {

      //   if(this.pay_promo && this.pay_promo.length > 0) {

      //     this.getPromoSumm(list)

      //     return;

      //   } else {
      //     this.pay_promo = null
      //   }

      // }

      console.log('daleeeee')


      // this.$store.dispatch(billActionTypes.getListBill,{
      //         client_id: this.client.client_id
      //       }).then((response2) => {
      //         if (response2.success)
      //           //if(resPrice && resPrice > 0){
      //             this.summ_cash_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
      //             this.summ_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
      //          // }
      //       })


      //       this.dialogPayment2 = true;

      //       return;



     if((this.buy_id && this.buy_id !== null && this.buy_id !== 'null') || this.type === 'exist' || (this.buy_id_payment && this.buy_id_payment !== null && this.buybuy_id_payment_id !== 'null')){

      
      console.log(this.client)
      console.log(this.type)
      console.log(this.buy_id)
      console.log(this.buy_id_payment)

      if(this.client && this.client.client_id){
      } else {
        let vv = JSON.parse(this.client)
        console.log(vv.client_id)
      }
      
      let pays_sum = 0

      if(this.saleInfo.sales && this.saleInfo.sales.pays) {
        pays_sum = this.saleInfo.sales.pays.reduce((res, i) => res + i.sum_in, 0)
      }

        this.$store.dispatch(billActionTypes.getListBill,{
              client_id: this.client.client_id
            }).then((response2) => {
              if (response2.success)
                //if(resPrice && resPrice > 0){
                  this.summ_cash_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
                  this.summ_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;

                  this.summ_cash_part = this.summ_cash_part - pays_sum
                  this.summ_part = this.summ_part - pays_sum
                  
               // }
            })

            //получаем бонусные счета после создания продажи
            this.$store.dispatch(billActionTypes.getListBonus,{
              client_id: this.client.client_id,
              buy_id: this.buy_id ? this.buy_id : this.buy_id_payment
            }).then((response3) => {
              if (response3.success){
                this.dialogPayment2 = true;
              }
            })

          return;
     }



            // this.$store.dispatch(billActionTypes.getListBill,{
            //   client_id: this.client.client_id
            // }).then((response2) => {
            //   if (response2.success)
            //     if(resPrice && resPrice > 0){
            //       this.summ_cash_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
            //       this.summ_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
            //     }
            // })

      if(this.client && this.client.client_id){
      } else {
        this.client = JSON.parse(this.client)
      }

      console.log('adsadsadd')

            console.log(this.client)

        this.$store.dispatch(salesActionTypes.createSalePart, {
            org_inn: (this.sale && this.sale.org && this.sale.org.inn) ? this.sale.org.inn : '1650387117',
            client_id: this.client.client_id,
            fio: this.userFIO,
            service_list: list,
            bonus_obj: this.main_bonus_part,
            deal_id: this.deal ? this.deal : null,
            promo:this.pay_promo ? this.pay_promo : null
        })
        .then((response) => {
          if (response.success) {
            //сохраняем айди продажи локально
            this.buy_id_payment = response.sale.buy_id;
            if(response.sale.service_list){
              this.buy_payment_list = response.sale.service_list
            }
            if(response.sale.sale_sum){
              this.summForPaymentPart = response.sale.sale_sum
            }
            this.$store.dispatch(billActionTypes.getListBill,{
              client_id: this.client.client_id
            }).then((response2) => {
              if (response2.success)
                //if(resPrice && resPrice > 0){
                  this.summ_cash_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
                  this.summ_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
                  console.log('получили основные')
                              //получаем бонусные счета после создания продажи
                            this.$store.dispatch(billActionTypes.getListBonus,{
                              client_id: this.client.client_id,
                              buy_id: this.buy_id_payment
                            }).then((response3) => {
                              if (response3.success){
                                console.log('получили бонусные')
                                this.dialogPayment2 = true;
                              }
                            })
                //}
            })



            
          } else {
            alert('Ошибка создания продажи!')
          }
        })
      
    },
    makeFreePayment(){

      console.log('freepayment')
      //return;

        // if(!this.sale || !this.sale.org || !this.sale.org.inn){
        //   alert('Не подключена или неполадки с кассой! Автоматически подставлена касса')
        //   return
        // }

        if(this.sale.org && this.sale.org && this.sale.org.inn){

        } else {
          if(!this.saleOrg){
            alert('Предупреждение. Не привязан ИНН (касса) и не выбрана организация!')
            return;
          }
        }

        if((this.dialogTypeOfPayment + 1) === 3) {
          if(!this.cashboxTerminal) {
            alert('Нет доступного терминала по выбранной кассе! Операция прекращается!')
            return;
          }
        }

        let list = [];
        let nomenclatures = this.type === 'new' ? this.nomenclatures : this.saleInfo.sales.buy_list;
        for (let item of nomenclatures) {

          let summik = (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count

          list.push({
            service_id: item.service.id,
            price: item.price,
            count: item.count,
            discount: item.discount,
            discount_summ: (item.price * (item.discount/100)) * item.count,
            sum: (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count,
            name:item.service.name,
            specialist_id: item.specialist_id,
            manager_id: (item.manager_id && item.manager_id !== undefined) ? item.manager_id : (getItem('user_id_1c') ? getItem('user_id_1c') : null),
            vat:{
              id:item.vat ? item.vat.id : null,
              sum:item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0,
            },
            vat_id: item.vat ? item.vat.id : null,
            vat_summ: item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0,
            vat_count: item.vat ? item.vat.count : null,
            marking_code: item.marking_code ? item.marking_code : null
          })
        }
        if (this.type === 'new') {
          this.$store.dispatch(salesActionTypes.createSale, {
            org_inn: this.sale.org.inn,
            client_id: this.client.client_id,
            fio: this.userFIO,
            service_list: list,
            deal_id: this.deal ? this.deal : null,
            promo:this.pay_promo ? this.pay_promo : null
          })
              .then((response) => {
                if (response.success) {
                  this.buy_id_payment = response.sale.buy_id;
                  this.$store.dispatch(cashboxActionTypes.saleReceipt, {
                    till_id: this.sale.org.serial,
                    type: this.dialogTypeOfPayment === 1 ? 4 : this.dialogTypeOfPayment + 1,
                    fio: this.userFIO,
                    service_list: list
                  })
                      .then((response) => {
                        if (response.success) {
                          this.$store.dispatch(cashboxActionTypes.makePayment, {
                            buy_id: this.buy_id_payment,
                            till_id: this.sale.org.serial,
                            type: this.dialogTypeOfPayment + 1,
                            summ: Math.abs(this.summForPayment),
                            check_number: response.receipt_number,
                            bill_id: (this.dialogTypeOfPayment + 1) === 2 ? this.main_bill?.deposit_id : null,
                            terminal_id: (this.dialogTypeOfPayment + 1) === 3 ? this.cashboxTerminal : null,
                            transaction_id: (this.dialogTypeOfPayment + 1) === 3 ? response.auth_code : null,
                            transaction_date: (this.dialogTypeOfPayment + 1) === 3 ? new Date() : null,
                            fio: this.userFIO,
                            service_list: list
                          })
                              .then((response) => {
                                if (response.success) {
                                  if (this.for === 'client') {
                                    this.$router.push({
                                      name: 'Desktop',
                                      params: {
                                        client_id: this.client.client_id
                                      }
                                    });
                                  } else {
                                    this.$store.dispatch(dealsActionTypes.updateSuccess, {
                                      deal_id: this.deal.id,
                                      buy_id: this.buy_id_payment
                                    }).then((response) => {
                                      if (response.success) {
                                        this.$router.push({
                                          name: 'Desktop',
                                          params: {
                                            client_id: this.client.client_id
                                          }
                                        });
                                      }
                                    })
                                  }
                                }
                              })
                        } else {
                          alert('Ошибка оплаты!');
                        }
                      })
                }
              })
        } else {
          this.$store.dispatch(cashboxActionTypes.saleReceipt, {
            till_id: this.sale.org.serial,
            type: this.dialogTypeOfPayment === 1 ? 4 : this.dialogTypeOfPayment + 1,
            fio: this.userFIO,
            service_list: list
          })
              .then((response) => {
                if (response.success) {
                  this.$store.dispatch(cashboxActionTypes.makePayment, {
                    buy_id: this.saleInfo.sales.id,
                    till_id: this.sale.org.serial,
                    type: this.dialogTypeOfPayment + 1,
                    summ: Math.abs(this.summForPayment),
                    check_number: response.receipt_number,
                    bill_id: (this.dialogTypeOfPayment + 1) === 2 ? this.main_bill?.deposit_id : null,
                    terminal_id: (this.dialogTypeOfPayment + 1) === 3 ? this.cashboxTerminal : null,
                    transaction_id: (this.dialogTypeOfPayment + 1) === 3 ? response.auth_code : null,
                    transaction_date: (this.dialogTypeOfPayment + 1) === 3 ? new Date() : null,
                    fio: this.userFIO,
                    service_list: list
                  })
                      .then((response) => {
                        if (response.success) {
                          if (this.for === 'client') {
                            this.$router.push({
                              name: 'Desktop',
                              params: {
                                client_id: this.client.client_id
                              }
                            });
                          } else {
                            this.$store.dispatch(dealsActionTypes.updateSuccess, {
                              deal_id: this.deal,
                              buy_id: this.saleInfo.sales.id
                            }).then((response) => {
                              if (response.success) {
                                this.$router.push({
                                  name: 'Desktop',
                                  params: {
                                    client_id: this.client.client_id
                                  }
                                });
                              }
                            })
                          }
                        }
                      })
                } else {
                  alert('Ошибка оплаты!');
                }
              })
        }
    },
    makePayment() {
      console.log('Оплата старт')
      console.log('makePayment')
      //return;
      console.log(this.cashboxTerminal)
      console.log(this.dialogTypeOfPayment)
      console.log(this.sale.org)

      if((this.dialogTypeOfPayment + 1) === 3) {
          if(!this.cashboxTerminal) {
            alert('Нет доступного терминала по выбранной кассе! Операция прекращается!')
            return;
          }
      }

      if (this.$refs.form.validate()) {
        console.log('summ to 1C:  ' + Math.abs(this.summForPayment))
        let list = [];
        let nomenclatures = this.type === 'new' ? this.nomenclatures : this.saleInfo.sales.buy_list;
        for (let item of nomenclatures) {

          let summik = (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count

          list.push({
            service_id: item.service.id,
            price: item.price,
            count: item.count,
            discount: item.discount,
            discount_summ: (item.price * (item.discount/100)) * item.count,
            sum: (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count,
            name:item.service.name,
            specialist_id: item.specialist_id,
            manager_id: (item.manager_id && item.manager_id !== undefined) ? item.manager_id : (getItem('user_id_1c') ? getItem('user_id_1c') : null),
            vat:{
              id:item.vat ? item.vat.id : null,
              sum:item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0,
            },
            vat_id: item.vat ? item.vat.id : null,
            vat_summ: item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0,
            vat_count: item.vat ? item.vat.count : null,
            marking_code: item.marking_code ? item.marking_code : null
          })
        }
        if (this.type === 'new') {
          this.$store.dispatch(salesActionTypes.createSale, {
            org_inn: this.sale.org.inn,
            client_id: this.client.client_id,
            fio: this.userFIO,
            service_list: list,
            vat:{
              id:item.vat ? item.vat.id : null,
              sum:item.vat ? ((item.price * item.vat.count)/(100+item.vat.count)) : 0,
            },
            vat_id: item.vat ? item.vat.id : null,
            vat_summ: item.vat ? ((item.price * item.vat.count)/(100+item.vat.count)) : 0,
            vat_count: item.vat ? item.vat.count : null,
            deal_id: this.deal ? this.deal : null,
            promo:this.pay_promo ? this.pay_promo : null
          })
              .then((response) => {
                if (response.success) {
                  this.buy_id_payment = response.sale.buy_id;
                  this.$store.dispatch(cashboxActionTypes.saleReceipt, {
                    till_id: this.sale.org.serial,
                    type: this.dialogTypeOfPayment === 1 ? 4 : this.dialogTypeOfPayment + 1,
                    fio: this.userFIO,
                    service_list: list
                  })
                      .then((response) => {
                        if (response.success) {
                          this.$store.dispatch(cashboxActionTypes.makePayment, {
                            buy_id: this.buy_id_payment,
                            till_id: this.sale.org.serial,
                            type: this.dialogTypeOfPayment + 1,
                            summ: Math.abs(this.summForPayment),
                            check_number: response.receipt_number,
                            bill_id: (this.dialogTypeOfPayment + 1) === 2 ? this.main_bill?.deposit_id : null,
                            terminal_id: (this.dialogTypeOfPayment + 1) === 3 ? this.cashboxTerminal : null,
                            transaction_id: (this.dialogTypeOfPayment + 1) === 3 ? response.auth_code : null,
                            transaction_date: (this.dialogTypeOfPayment + 1) === 3 ? new Date() : null,
                            fio: this.userFIO,
                            service_list: list
                          })
                              .then((response) => {
                                if (response.success) {
                                  if (this.for === 'client') {
                                    this.$router.push({
                                      name: 'Desktop',
                                      params: {
                                        client_id: this.client.client_id
                                      }
                                    });
                                  } else {
                                    this.$store.dispatch(dealsActionTypes.updateSuccess, {
                                      deal_id: this.deal.id,
                                      buy_id: this.buy_id_payment
                                    }).then((response) => {
                                      if (response.success) {
                                        this.$router.push({
                                          name: 'Desktop',
                                          params: {
                                            client_id: this.client.client_id
                                          }
                                        });
                                      }
                                    })
                                  }
                                }
                              })
                        } else {
                          alert('Ошибка оплаты!');
                        }
                      })
                }
              })
        } else {
          this.$store.dispatch(cashboxActionTypes.saleReceipt, {
            till_id: this.sale.org.serial,
            type: this.dialogTypeOfPayment === 1 ? 4 : this.dialogTypeOfPayment + 1,
            fio: this.userFIO,
            service_list: list
          })
              .then((response) => {
                if (response.success) {
                  this.$store.dispatch(cashboxActionTypes.makePayment, {
                    buy_id: this.saleInfo.sales.id,
                    till_id: this.sale.org.serial,
                    type: this.dialogTypeOfPayment + 1,
                    summ: Math.abs(this.summForPayment),
                    check_number: response.receipt_number,
                    bill_id: (this.dialogTypeOfPayment + 1) === 2 ? this.main_bill?.deposit_id : null,
                    terminal_id: (this.dialogTypeOfPayment + 1) === 3 ? this.cashboxTerminal : null,
                    transaction_id: (this.dialogTypeOfPayment + 1) === 3 ? response.auth_code : null,
                    transaction_date: (this.dialogTypeOfPayment + 1) === 3 ? new Date() : null,
                    fio: this.userFIO,
                    service_list: list
                  })
                      .then((response) => {
                        if (response.success) {
                          if (this.for === 'client') {
                            this.$router.push({
                              name: 'Desktop',
                              params: {
                                client_id: this.client.client_id
                              }
                            });
                          } else {
                            this.$store.dispatch(dealsActionTypes.updateSuccess, {
                              deal_id: this.deal,
                              buy_id: this.saleInfo.sales.id
                            }).then((response) => {
                              if (response.success) {
                                this.$router.push({
                                  name: 'Desktop',
                                  params: {
                                    client_id: this.client.client_id
                                  }
                                });
                              }
                            })
                          }
                        }
                      })
                } else {
                  alert('Ошибка оплаты!');
                }
              })
        }
      }
    },
    makePaymentPart() {
      console.log('Оплата старт')
      console.log('makePARTPayment')
      console.log(this.main_bonus_part)
      console.log(this.main_bill_part)
      console.log(this.main_bill_part2)
      //return;
      console.log(this.cashboxTerminal)
      console.log(this.dialogTypeOfPayment)
      console.log(this.sale.org)

      console.log('--')
      console.log(this.cash_in_part)
      console.log(this.cash_in_part_pre)
      console.log(this.summ_card_part_pre)
      console.log(this.summ_bill_part_pre)
      console.log(this.summ_bonus_part_pre)
      console.log('--')

      

      let typeOfPartPayment = []

      if(!this.cash_in_part || this.cash_in_part <= 0){
        alert('Не верная сумма оплаты!');
        return;
      }

      // if(Math.abs(this.summForPaymentPart) > Math.abs(this.cash_in_part)){
      //   alert('Итоговая сумма внесено меньше суммы оплаты!');
      //   return;
      // }

      if(Math.abs(this.summForPaymentPart) > Math.abs(this.cash_in_part)){
        if (confirm("Итоговая сумма внесено меньше суммы оплаты! Продолжить?") == true) {
          console.log('continue')
        } else {
          return;
        }
      }

      if(this.summ_card_part_pre && +this.summ_card_part_pre > 0) {
          if(!this.cashboxTerminal) {
            alert('Нет доступного терминала по выбранной кассе! Операция прекращается!')
            //return;
          }
      }

      if(this.cash_in_part_pre && (+this.cash_in_part_pre > 0) && !this.cash_in_part_setted) {
        if (confirm("Внимение, не подтверждена сумма для оплаты наличными!") == true) {
          console.log('continue')
          
        } else {
          return;
        }
      } else if (this.cash_in_part_pre && (+this.cash_in_part_pre > 0)){
        typeOfPartPayment.push(0)
      }

      if(this.summ_card_part_pre && (+this.summ_card_part_pre > 0) && !this.card_part_setted) {
        if (confirm("Внимение, не подтверждена сумма для оплаты картой!") == true) {
          console.log('continue')
          
        } else {
          return;
        }
      } else if (this.summ_card_part_pre && (+this.summ_card_part_pre > 0) ){
        typeOfPartPayment.push(2)
      }

      if(this.summ_bill_part_pre && (+this.summ_bill_part_pre > 0) && !this.bill_part_setted) {
        if (confirm("Внимение, не подтверждена сумма для оплаты с личного счёта!") == true) {
          console.log('continue')
        } else {
          return;
        }
      } else if (this.summ_bill_part_pre && (+this.summ_bill_part_pre > 0)){
        typeOfPartPayment.push(1)
      }

      if(this.summ_bill_part_pre2 && (+this.summ_bill_part_pre2 > 0) && !this.bill_part_setted2) {
        if (confirm("Внимение, не подтверждена сумма для оплаты с личного счёта 2!") == true) {
          console.log('continue')
        } else {
          return;
        }
      } else if (this.summ_bill_part_pre2 && (+this.summ_bill_part_pre2 > 0)){
        typeOfPartPayment.push(7)
      }

      if(this.summ_bonus_part_pre && (+this.summ_bonus_part_pre > 0) && !this.bonus_part_setted) {
        if (confirm("Внимение, не подтверждена сумма для оплаты с бонусного счёта!") == true) {
          console.log('continue')
          
        } else {
          return;
        }
      } else if (this.summ_bonus_part_pre && (+this.summ_bonus_part_pre > 0)){
        this.main_bonus_part.val = this.summ_bonus_part_pre
        typeOfPartPayment.push(3)
      }

      let calculatedSumm = (+this.cash_in_part_pre + (+this.summ_card_part_pre) + (+this.summ_bill_part_pre) + (+this.summ_bill_part_pre2) + (+this.summ_bonus_part_pre))
      console.log(calculatedSumm)
      console.log(this.summForPaymentPart)

      if(calculatedSumm > Math.abs(this.summForPaymentPart)){
        if (confirm("Сумма оплаты ("+Math.abs(this.summForPaymentPart)+") не совпадает с итоговой суммой частичных оплат ()"+calculatedSumm+")! Продолжить?") == true) {
        } else {
          return;
        }
      }
      

      //if (this.$refs.form.validate()) {
        console.log('summ to 1C:  ' + Math.abs(this.summForPaymentPart))
        console.log('summ to 1C:  ' + Math.abs(this.summ_part))
        // if(this.dialogTypeOfPaymentPart.includes(0)){
        //   if(!this.summ_cash_part || +this.summ_cash_part <= 0){
        //     alert('Неверная сумма к оплате наличными!');
        //     return;
        //   }
        //   if(!this.cash_in_part || +this.cash_in_part <= 0){
        //     alert('Неверная сумма внесено при оплате наличными!');
        //     return;
        //   }
        // }
          // if(!this.summ_bill_part || +this.summ_bill_part <= 0){
          //   alert('Неверная сумма к оплате со счёта!');
          //   return;
          // }
          if(this.main_bill_part && +this.summ_bill_part_pre > this.main_bill_part.deposit_balance){
            alert('Сумма списания со счёта превышает остаток на балансе счёта!');
            return;
          }
          if(this.main_bill_part2 && +this.summ_bill_part_pre2 > this.main_bill_part2.deposit_balance){
            alert('Сумма списания со счёта превышает остаток на балансе счёта!');
            return;
          }
          if(this.main_bonus_part && +this.summ_bonus_part_pre > this.main_bonus_part.bonus_balance){
            alert('Сумма списания с бонусного счёта превышает остаток на балансе счёта!');
            return;
          }
        // if(this.dialogTypeOfPaymentPart.includes(2)){
        //   if(!this.summ_card_part || +this.summ_card_part <= 0){
        //     alert('Неверная сумма к оплате картой!');
        //     return;
        //   }
        // }

        if(!this.sale || !this.sale.org|| !this.sale.org.inn) {
          alert('Не подключена или не выбрана касса!');
        }

        console.log(typeOfPartPayment)

        let list = [];
        let nomenclatures = this.type === 'new' ? this.nomenclatures : this.saleInfo.sales.buy_list;
        for (let item of nomenclatures) {

          console.log(item)

          let summik = (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count

          list.push({
            service_id: item.service.id,
            price: item.price,
            count: item.count,
            discount: item.discount,
            discount_summ: (item.price * (item.discount/100)) * item.count,
            sum: (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count,
            name:item.service.name,
            specialist_id: item.specialist_id,
            manager_id: (item.manager_id && item.manager_id !== undefined) ? item.manager_id : (getItem('user_id_1c') ? getItem('user_id_1c') : null),
            vat_id: item.vat ? item.vat.id : null,
            vat_summ: item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0,
            vat_count: item.vat_count ? item.vat_count : (item.vat.count ? item.vat.count : null),
            marking_code: item.marking_code ? item.marking_code : null
          })

          if(this.buy_payment_list && this.buy_payment_list.length > 0) {
            for(let j = 0; j < this.buy_payment_list.length; j++) {
                if(item.service.id === this.buy_payment_list[j].service_id) {
                  this.buy_payment_list[j].vat_count = item.vat_count;
                  this.buy_payment_list[j].vat_summ = item.vat ? ((summik * item.vat.count)/(100+item.vat.count)) : 0;
                  this.buy_payment_list[j].marking_code = item.marking_code ? item.marking_code : null;
                }
            }
          }
        }

        if (this.type === 'new') {

          console.log(this.buy_payment_list)
          console.log(list)

          //let llist = list

      
          
          
          // this.$store.dispatch(salesActionTypes.createSalePart, {
          //   org_inn: this.sale.org.inn,
          //   client_id: this.client.client_id,
          //   fio: this.userFIO,
          //   service_list: list,
          //   bonus_obj: this.main_bonus_part
          // })
          //     .then((response) => {
          //       if (response.success) {
          //         this.buy_id_payment = response.sale.buy_id;
          //         if(response.sale.service_list){
          //           list = response.sale.service_list
          //         }
          //         if(response.sale.sale_sum){
          //           this.summForPaymentPart = response.sale.sale_sum
          //         }


                  this.$store.dispatch(cashboxActionTypes.saleReceiptPart, {
                    till_id: this.sale.org.serial,
                    type: typeOfPartPayment,
                    cash: this.cash_in_part_pre,
                    card: this.summ_card_part_pre,
                    bill: this.summ_bill_part_pre,
                    bill2: this.summ_bill_part_pre2,
                    bonus: this.summ_bonus_part_pre,
                    bonus_obj: this.main_bonus_part,
                    fio: this.userFIO,
                    service_list: this.buy_payment_list ? this.buy_payment_list : list,
                    buy_id: this.buy_id_payment,
                    summ: Math.abs(this.summForPaymentPart),
                    bill_id: (this.summ_bill_part_pre && +this.summ_bill_part_pre > 0) ? this.main_bill_part?.deposit_id : null,
                    bill_id2: (this.summ_bill_part_pre2 && +this.summ_bill_part_pre2 > 0) ? this.main_bill_part2?.deposit_id : null,
                    terminal_id: (this.summ_card_part_pre && +this.summ_card_part_pre > 0) ? this.cashboxTerminal : null,
                    transaction_date: new Date(),
                    to_pay: Math.abs(this.cash_in_part)
                  })
                      .then((response) => {
                                if (response.success) {
                                  if (this.for === 'client') {
                                    this.$router.push({
                                      name: 'Desktop',
                                      params: {
                                        client_id: this.client.client_id
                                      }
                                    });
                                  } else {
                                    this.$store.dispatch(dealsActionTypes.updateSuccess, {
                                      deal_id: this.deal.id,
                                      buy_id: this.buy_id_payment
                                    }).then((response) => {
                                      if (response.success) {
                                        this.$router.push({
                                          name: 'Desktop',
                                          params: {
                                            client_id: this.client.client_id
                                          }
                                        });
                                      }
                                    })
                                  }
                                } else {
                                  alert('Ошибка оплаты 2!');
                                }
                    })
                        
         
        } else {
          // this.$store.dispatch(cashboxActionTypes.saleReceiptPart, {
          //   till_id: this.sale.org.serial,
          //   type: this.dialogTypeOfPaymentPart,
          //   cash: this.summ_cash_part,
          //   card: this.summ_card_part,
          //   bill: this.summ_bill_part,
          //   fio: this.userFIO,
          //   service_list: this.buy_payment_list ? this.buy_payment_list : list
          // })
          //     .then((response) => {
          //       if (response.success) {
          //         this.$store.dispatch(cashboxActionTypes.makePaymentPart, {
          //           buy_id: this.saleInfo.sales.id,
          //           till_id: this.sale.org.serial,
          //           type: this.dialogTypeOfPaymentPart,
          //           cash: this.summ_cash_part,
          //           card: this.summ_card_part,
          //           bill: this.summ_bill_part,
          //           summ: Math.abs(this.summForPaymentPart),
          //           check_number: response.receipt_number,
          //           bill_id: this.dialogTypeOfPaymentPart.includes(1) ? this.main_bill_part?.deposit_id : null,
          //           terminal_id: this.dialogTypeOfPaymentPart.includes(2) ? this.cashboxTerminal : null,
          //           transaction_id: this.dialogTypeOfPaymentPart.includes(2) ? response.auth_code : null,
          //           transaction_date: new Date(),
          //           fio: this.userFIO,
          //           service_list: list
          //         })
          //             .then((response) => {
          //               if (response.success) {
          //                 if (this.for === 'client') {
          //                   this.$router.push({
          //                     name: 'Desktop',
          //                     params: {
          //                       client_id: this.client.client_id
          //                     }
          //                   });
          //                 } else {
          //                   this.$store.dispatch(dealsActionTypes.updateSuccess, {
          //                     deal_id: this.deal,
          //                     buy_id: this.saleInfo.sales.id
          //                   }).then((response) => {
          //                     if (response.success) {
          //                       this.$router.push({
          //                         name: 'Desktop',
          //                         params: {
          //                           client_id: this.client.client_id
          //                         }
          //                       });
          //                     }
          //                   })
          //                 }
          //               }
          //             })
          //       } else {
          //         alert('Ошибка оплаты!');
          //       }
          //     })

          console.log('-----')
          console.log(this.buy_id_payment)


          this.$store.dispatch(cashboxActionTypes.saleReceiptPart, {
                    till_id: this.sale.org.serial,
                    type: typeOfPartPayment,
                    cash: this.cash_in_part_pre,
                    card: this.summ_card_part_pre,
                    bill: this.summ_bill_part_pre,
                    bill2: this.summ_bill_part_pre2,
                    bonus: this.summ_bonus_part_pre,
                    bonus_obj: this.main_bonus_part,
                    fio: this.userFIO,
                    service_list: this.buy_payment_list ? this.buy_payment_list : list,
                    buy_id: this.saleInfo.sales.id,
                    summ: Math.abs(this.summForPaymentPart),
                    bill_id: (this.summ_bill_part_pre && +this.summ_bill_part_pre > 0) ? this.main_bill_part?.deposit_id : null,
                    bill_id2: (this.summ_bill_part_pre2 && +this.summ_bill_part_pre2 > 0) ? this.main_bill_part2?.deposit_id : null,
                    terminal_id: (this.summ_card_part_pre && +this.summ_card_part_pre > 0) ? this.cashboxTerminal : null,
                    transaction_date: new Date(),
                    credit_summ: Math.abs(this.cash_in_part)
                  })
                      .then((response) => {
                                if (response.success) {
                                  if (this.for === 'client') {
                                    this.$router.push({
                                      name: 'Desktop',
                                      params: {
                                        client_id: this.client.client_id
                                      }
                                    });
                                  } else {
                                    this.$store.dispatch(dealsActionTypes.updateSuccess, {
                                      deal_id: this.deal.id,
                                      buy_id: this.buy_id_payment
                                    }).then((response) => {
                                      if (response.success) {
                                        this.$router.push({
                                          name: 'Desktop',
                                          params: {
                                            client_id: this.client.client_id
                                          }
                                        });
                                      }
                                    })
                                  }
                                } else {
                                  alert('Ошибка оплаты 2!');
                                }
                    })
        }
      //}
    },
    cancelReceipt() {
      this.$store.dispatch(cashboxActionTypes.cancelReceipt, {
        till_id: this.sale.org.serial,
        fio: this.userFIO
      })
    },
    ChangeSaleOrg(kk){
      this.sale_org_changed = true

      let confirmText = "При смене организации сбросится выбранный список услуг (сервисов)."

      if(!kk){
        alert(confirmText);
      }
      

      this.nomenclatures = []

      let org_inn = (this.sale && this.sale.org && this.sale.org.inn) ? this.sale.org.inn : (this.saleOrg ? this.saleOrg.inn : 0)
      this.$store.dispatch(salesActionTypes.getSalesAllList, {org_inn});

      // if (confirm(confirmText) == true) {
      //   this.nomenclatures []
      // } else {

      // }

    },
    setCashPart(status){

      if(status && status === true) {
        if((+this.cash_in_part >= +this.summ_cash_part) && status){
          alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
          this.canAddSumm = false
          this.ifCashPay = false
          return;
        }

        if(+this.cash_in_part_pre > 0){
          this.cash_in_part_setted = status
          this.cash_in_part = status ? (this.cash_in_part + (+this.cash_in_part_pre)) : (this.cash_in_part - (+this.cash_in_part_pre))
        } else {
          this.cash_in_part_pre = 0
        }

      } else {
        this.cash_in_part = this.cash_in_part - (+this.cash_in_part_pre)
        this.cash_in_part_pre = 0
        this.cash_in_part_setted = status
        this.ifCashPay = false
      }
   
      // if(this.cash_in_part > this.summ_cash_part){
      //   alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
      //   this.ifCashPay = false
      // }
 
     


    },
    setCardPart(status){

      if(status && status === true) {
        if((+this.cash_in_part >= +this.summ_cash_part) && status){
          alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
          this.canAddSumm = false
          this.ifCardPay = false
          return;
        }
        
        if(+this.summ_card_part_pre > 0){
          this.card_part_setted = status
          this.cash_in_part = status ? (this.cash_in_part + (+this.summ_card_part_pre)) : (this.cash_in_part - (+this.summ_card_part_pre))
        } else {
          this.summ_card_part_pre = 0
        }
   
      } else {
        this.card_part_setted = status
        this.cash_in_part = this.cash_in_part - (+this.summ_card_part_pre)
        this.summ_card_part_pre = 0
        this.ifCardPay = false
      }

   
      // if(this.cash_in_part > this.summ_cash_part){
      //   alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
      //   this.ifCardPay = false
      // }
   

    },
    setBillPart(status){

      if(status && status === true) {
        if((this.cash_in_part > this.summ_cash_part) && status){
          alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
          this.main_bill_part = null
          this.canAddSumm = false
        }

        if(+this.summ_bill_part_pre > 0){
          this.bill_part_setted = status
          this.cash_in_part = status ? (this.cash_in_part + (+this.summ_bill_part_pre)) : (this.cash_in_part - (+this.summ_bill_part_pre))
        } else {
          this.summ_bill_part_pre = 0
        }
      } else {
        this.bill_part_setted = status
        this.cash_in_part = this.cash_in_part - (+this.summ_bill_part_pre)
        this.summ_bill_part_pre = 0   
      }

    
    },
    setBillPart2(status){

      if(status && status === true) {
        if((this.cash_in_part > this.summ_cash_part) && status){
          alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
          this.main_bill_part2 = null
          this.canAddSumm = false
        }

        
        if(+this.summ_bill_part_pre2 > 0){
          this.bill_part_setted2 = status
          this.cash_in_part = status ? (this.cash_in_part + (+this.summ_bill_part_pre2)) : (this.cash_in_part - (+this.summ_bill_part_pre2))
        } else {
          this.summ_bill_part_pre2 = 0
        }

      } else {
        this.bill_part_setted2 = status
        this.cash_in_part = this.cash_in_part - (+this.summ_bill_part_pre2)
        this.summ_bill_part_pre2 = 0   

      }

    },
    setBonusPart(status){

      if(status && status === true) {
        if((this.cash_in_part > this.summ_cash_part) && status){
          alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
          this.main_bonus_part = null
          this.canAddSumm = false
        }

        if(+this.summ_bonus_part_pre > this.main_bonus_part.bonus_limit){
          alert('Превышен лимит по бонусному счёту!')
          this.summ_bonus_part_pre = this.main_bonus_part.bonus_limit
          this.bonus_part_setted = false
        }
        if(+this.summ_bonus_part_pre > 0){
          this.bonus_part_setted = status
          this.cash_in_part = status ? (this.cash_in_part + (+this.summ_bonus_part_pre)) : (this.cash_in_part - (+this.summ_bonus_part_pre))

        } else {
          this.summ_bonus_part_pre = 0
        }
      } else {
        this.cash_in_part = this.cash_in_part - (+this.summ_bonus_part_pre)
        this.summ_bonus_part_pre = 0
        this.bonus_part_setted = status
      }

    


      console.log(this.summ_bonus_part_pre)
      console.log(this.main_bonus_part.bonus_limit)
      console.log(this.summ_cash_part)
      console.log(this.main_bonus_part)

    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.cashbox.isLoading,
      doingPayment: state => state.cashbox.doingPayment,
      isLoadingSale: state => state.sale.isLoadingSale,
      listAllServices: state => state.sale.listAllServices,
      listBill: state => state.bill.list,
      listBonus: state => state.bill.bonus,
      saleInfo: state => state.sale.saleInfo,
      rentalsTypes: state => state.sale.rentalsTypes,
      userFIO: state => state.userFIO,
      specialist: state => state.lesson.specialist,
      validationErrors: state => state.cashbox.validationErrors,
      listOrganizations: state => state.sale.listOrganizations
    }),
    searchPackages() {
      let res = this.caseSensitive
        ? sayMyNane(item, search, textKey)
        : undefined

        function sayMyNane(item, search, textKey){
          (item[textKey2].indexOf(search) > -1)
        }

      return res

    },
    
    summ() {
      return this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
    },
    summForPayment() {
      let money = null;
      if (this.dialogTypeOfPayment === 0) {
        money = this.cash_in <= this.summ ? this.cash_in : this.summ;
      }
      if (this.dialogTypeOfPayment === 1) {
        money = this.cash_from_bill;
      }
      if (this.dialogTypeOfPayment === 2) {
        money = this.summ;
      }
      if (this.dialogTypeOfPayment === 3) {
        money = this.summ;
      }
      return money;
    },
    summForPaymentPart() {
      let money = null;
      if(this.dialogTypeOfPaymentPart.includes(0)){
        money = this.cash_in_part <= this.summ_part ? this.cash_in_part : this.summ_part;
      }
      if (this.dialogTypeOfPaymentPart.includes(1)) {
        if(this.dialogTypeOfPaymentPart.includes(0) && this.dialogTypeOfPaymentPart.includes(2)){
          money = +this.summ_bill_part + (+this.summ_cash_part) + (+this.summ_card_part);
        } else if(this.dialogTypeOfPaymentPart.includes(0)){
          money = +this.summ_bill_part + (+this.summ_cash_part);
        } else if(this.dialogTypeOfPaymentPart.includes(2)){
          money = +this.summ_bill_part + (+this.summ_card_part);
        } else {
          money = this.summ_bill_part;
        }
      }
      if (this.dialogTypeOfPaymentPart.includes(2)) {
        if(this.dialogTypeOfPaymentPart.includes(0) && this.dialogTypeOfPaymentPart.includes(1)){
          money = +this.summ_bill_part + (+this.summ_cash_part) + (+this.summ_card_part);
        } else if(this.dialogTypeOfPaymentPart.includes(0)){
          money = +this.summ_card_part + (+this.summ_cash_part);
        } else if(this.dialogTypeOfPaymentPart.includes(1)){
          money = +this.summ_bill_part + (+this.summ_card_part);
        } else {
          money = this.summ_card_part;
        }
      }

      return money;
    }
  },
  mounted() {
    this.type !== undefined ? setItem('sale-type',this.type) : this.type = getItem('sale-type');
    this.for !== undefined ? setItem('sale-for',this.for) : this.for = getItem('sale-for');
    this.deal !== undefined ? setItem('sale-deal',this.deal) : this.deal = getItem('sale-deal');
    console.log(this.client)
    console.log(getItem('sale-client'))
    console.log(JSON.parse(getItem('sale-client')))

    if(this.client && this.client.id){
      setItem('sale-client',JSON.stringify(this.client))
    } else if(this.client && this.client.client_id){
      setItem('sale-client',JSON.stringify(this.client))
    } else {

      this.client = getItem('sale-client')

      if(this.client && this.client.client_id && this.client.client_id !== undefined && this.client.client_id !== 'undefined'){

      } else {
        this.client = JSON.parse(this.client)
      }
      
    }
    console.log(getItem('sale-buy_id'))
    this.buy_id !== undefined ? setItem('sale-buy_id',this.buy_id) : this.buy_id = getItem('sale-buy_id');
    console.log(this.buy_id)
    console.log(this.listCashbox)
    //console.log(this.listCashboxDef)

    if (JSON.parse(getItem('select_org-sale')) && this.listCashbox) {
      this.sale.org = JSON.parse(getItem('select_org-sale'));
    } else {
      this.sale.org = this.listCashbox ? this.listCashbox[0] : null;
    }
    this.fetchFeed(this.buy_id, this.type);
    //this.setCashboxTerminal()
    // this.summ_cash_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;

    console.log(this.type)
    // setItem('sale-buyer-client_id',undefined)
    // setItem('sale-buyer-client_name_buyer',undefined)
    // setItem('sale-buyer-org_inn',undefined)
    // setItem('sale-buyer-service_list_buyer',undefined)
    // setItem('sale-buyer-buy_id',undefined)
    // setItem('sale-buyer-summ_cash_part_buyer',undefined)
    // setItem('sale-buyer-summ_part_buyer',undefined)

    this.$store.dispatch(lessonActionTypes.getSpecialistList,{})
    .then((response) => {
        if(response && response.success) {
          this.specialist_def = response.specialist
        }
    });
    // this.$store.dispatch(lessonActionTypes.getSpecialistList,{manager_type:true})
    // .then((response) => {
    //     if(response && response.success) {
    //       this.manager_def = response.specialist
    //     }
    // });

    if(getItem('buyer_saler') && getItem('buyer_saler') !== null && getItem('buyer_saler') !== undefined && getItem('buyer_saler') !== 'null'){
      this.saleOrg = JSON.parse(getItem('buyer_saler'))
      this.ChangeSaleOrg(true)
    }


  },
  watch: {
    canAddSumm(){
     
    },
    summ_cash_part(){
      if(this.dialogTypeOfPaymentPart.includes(2) && !this.dialogTypeOfPaymentPart.includes(1)){
        this.summ_card_part = this.summ_part - this.summ_cash_part;
        this.cash_out_part = (+this.cash_in_part + (+this.summ_card_part)) > this.summ_part ? ((+this.cash_in_part + (+this.summ_card_part)) - (+this.summ_part)) : 0;
      }
    },
    summ_card_part(){

      if(this.dialogTypeOfPaymentPart.includes(0) && !this.dialogTypeOfPaymentPart.includes(1)){
        this.summ_cash_part = this.summ_part - this.summ_card_part;
        this.cash_out_part = (+this.cash_in_part + (+this.summ_card_part)) > this.summ_part ? ((+this.cash_in_part + (+this.summ_card_part)) - (+this.summ_part)) : 0;
      }
    },
    cash_in_part() {

      if(this.dialogTypeOfPaymentPart.includes(2) && !this.dialogTypeOfPaymentPart.includes(1)){
        this.cash_out_part = (+this.cash_in_part + (+this.summ_card_part)) > this.summ_part ? ((+this.cash_in_part + (+this.summ_card_part)) - (+this.summ_part)) : 0;
      } else {
        this.cash_out_part = this.cash_in_part > this.summ_cash_part ? (this.cash_in_part - this.summ_cash_part) : 0;
      }
    },
    summ_bill_part(){
      console.log(this.summ_bill_part)
    },
    main_bill_part_def(){
      console.log(this.main_bill_part_def)
      if(this.main_bill_part && this.main_bill_part !== null){
        //уже выбран один
        console.log('уже есть один')
        
        if(this.main_bill_part_def !== null){

          if(+this.main_bill_part_def.deposit_balance > 0){
            this.main_bill_part2 = this.main_bill_part_def
          }

          if(+this.cash_in_part >= +this.summ_cash_part){
            alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
            this.canAddSumm = false
            if(this.main_bill_part_def.deposit_id === this.main_bill_part2.deposit_id){
              this.main_bill_part2 = null
            }
            
            return;
          }
          if(+this.main_bill_part2.deposit_balance <= 0){
            alert('Не верный баланс счёта')
            this.bill_part_setted2 = true

            this.cash_in_part = this.cash_in_part - (+this.summ_bill_part_pre2)

            this.summ_bill_part_pre2 = 0

          } else {
            this.bill_part_setted2 = false
          }
        }

      } else {

        if(this.main_bill_part_def !== null){
          
          if(+this.main_bill_part_def.deposit_balance > 0){
            this.main_bill_part = this.main_bill_part_def
          }
          
          if(+this.cash_in_part >= +this.summ_cash_part){
            alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
            this.canAddSumm = false
            if(this.main_bill_part_def.deposit_id === this.main_bill_part.deposit_id){
              this.main_bill_part = null
            }
            return;
          }
          if(+this.main_bill_part.deposit_balance <= 0){
            alert('Не верный баланс счёта')
            this.bill_part_setted = true

            this.cash_in_part = this.cash_in_part - (+this.summ_bill_part_pre)

            this.summ_bill_part_pre = 0

          } else {
            this.bill_part_setted = false
          }
        }

      }
    },
    main_bonus_part(){
      if(this.main_bonus_part !== null){
        console.log(this.cash_in_part_pre)
        console.log(this.cash_in_part)
        console.log(this.summ_bonus_part_pre)
        console.log(this.main_bonus_part)
        if(+this.cash_in_part >= +this.summ_cash_part){
          alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
          this.canAddSumm = false
          this.main_bonus_part = null
          return;
        }

        if(+this.main_bonus_part.deposit_balance <= 0){
          this.bonus_part_setted = true

          this.cash_in_part = this.cash_in_part - (+this.summ_bonus_part_pre)

          this.summ_bonus_part_pre = 0

        } else {
          this.bonus_part_setted = false
          this.summ_bonus_part_pre = this.main_bonus_part.bonus_limit
        }
      }
    },
    cash_in() {
      this.cash_out = this.cash_in > this.summ ? (this.cash_in - this.summ) : 0;
    },
    'sale.org'() {
      console.log(this.sale.org)
      setItem('select_org-sale',JSON.stringify(this.sale.org))
      if(+this.term_i === 0){
        this.term_i = 1
      } else {
        this.term_i = 0
      }
      this.setCashboxTerminal()
    },
    'salePart'(){
      console.log(this.salePart)
    },
    'dialogTypeOfPaymentPart'(){
      console.log(this.dialogTypeOfPaymentPart)
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  unmounted () {
    window.removeEventListener('scroll', this.handleScroll);
  },
}
</script>

<style scoped>
#horizontal_tabs {
  flex: none;
  width: auto !important;
}
.logo-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: #F1F1F1;
  border-radius: 25px;
}
.total-price > span {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}
.service {
  width: 100%;
  padding: 0px 16px;
  gap: 16px;
  background: #ffffff;
  border: 1px solid #E0E0E0;
  border-radius: 12px;
  margin-top: 10px;
}
.service-title {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.service-price {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
}
.new-client {
  border-top: 1px solid #E0E0E0;
  margin: 0 16px 20px 16px;
  padding-top: 20px;

}
.new-client > span {
  margin-top: 20px;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #629F33;
  cursor: pointer;
}
.payment-text {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.no-data-text {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #767676;
  padding-left: 16px;
  padding-bottom: 16px;
}
.custom__select {
  width: 330px;
}
.custom__select.v-select--is-menu-active {
  outline: 4px solid #E0ECD6;
}
.search-service.v-input--is-focused {
  outline: 4px solid #E0ECD6;
}
.custom__text-field {
  font-size: 12px;
  font-weight: normal;
  padding: 20px 16px 16px 16px;
}
.custom__menu {
  max-height: 112px !important;
  max-width: 199px !important;
}
.custom__menu > .v-list > .v-list-item {
  min-height: 32px !important;
}
.custom__menu > .v-list > .v-list-item > .v-list-item__title {
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
}
.vd-activator .custom__datepicker {
  width: 92% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #969696 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: space-between !important;
  margin-top: 9px !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}


.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 48px!important;
  color: #767676!important;
  padding: 12px 20px;
  text-transform: none;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}
.v-btn-toggle > v-btn {
  width: 25%;
}
.theme--light.v-btn.v-btn--has-bg {
  background-color: #ffffff;
}
.v-btn-toggle > .v-btn.v-btn--active > .v-btn__content > .v-icon {
  color: #629F33;
}

.button__secondary-text {
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  text-transform: none !important;
}
.vd-activator .custom__datepicker2 {
border: unset !important;
    background: transparent !important;
    padding: 13px 16px !important;
    margin-top: 0px !important;
}

.vd-activator .custom__datepicker44 {

    margin: 0px 0px 0px -12px !important;
    border:1px solid #e0e0e0 !important;
}

</style>